import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.unshift.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-40cf1a77"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "out-box"
};
const _hoisted_2 = {
  class: "content-box"
};
const _hoisted_3 = {
  style: {
    "display": "flex",
    "min-height": "120px",
    "background-color": "white",
    "box-shadow": "5px 0px 9px 0px #e5e9f2"
  }
};
const _hoisted_4 = {
  class: "shop-info-box"
};
const _hoisted_5 = {
  class: "shop-info-item"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "width": "8px",
    "display": "inline-block"
  }
}, null, -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "width": "8px",
    "display": "inline-block"
  }
}, null, -1));
const _hoisted_8 = {
  class: "shop-info-item"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "width": "8px",
    "display": "inline-block"
  }
}, null, -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "width": "8px",
    "display": "inline-block"
  }
}, null, -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "width": "8px",
    "display": "inline-block"
  }
}, null, -1));
const _hoisted_12 = {
  class: "shop-info-item"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "width": "8px",
    "display": "inline-block"
  }
}, null, -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "width": "8px",
    "display": "inline-block"
  }
}, null, -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "width": "8px",
    "display": "inline-block"
  }
}, null, -1));
const _hoisted_16 = {
  style: {
    "display": "flex",
    "flex": "1",
    "background-color": "white",
    "margin-top": "20px",
    "position": "relative",
    "min-height": "603px"
  }
};
const _hoisted_17 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_18 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "flex": "1"
  }
};
const _hoisted_19 = {
  style: {
    "margin-left": "20px",
    "margin-bottom": "20px"
  }
};
const _hoisted_20 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "flex": "1",
    "overflow": "hidden"
  }
};
const _hoisted_21 = {
  style: {
    "display": "flex",
    "flex": "1",
    "color": "#777777"
  }
};
const _hoisted_22 = {
  style: {
    "width": "590px",
    "display": "flex",
    "flex-direction": "column"
  }
};
const _hoisted_23 = {
  style: {
    "display": "flex",
    "justify-content": "space-between"
  }
};
const _hoisted_24 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "margin-left": "20px",
    "width": "352px",
    "height": "264px",
    "min-width": "352px",
    "min-height": "264px"
  }
};
const _hoisted_25 = {
  key: 1,
  style: {
    "width": "352px",
    "height": "264px",
    "min-width": "352px",
    "min-height": "264px"
  }
};
const _hoisted_26 = {
  style: {
    "width": "205px",
    "height": "264px",
    "overflow-y": "auto",
    "position": "relative"
  }
};
const _hoisted_27 = {
  key: 0,
  style: {
    "position": "absolute",
    "inset": "0",
    "display": "flex",
    "padding": "5px",
    "flex-shrink": "0",
    "flex-wrap": "wrap",
    "align-content": "flex-start",
    "align-items": "flex-start",
    "justify-content": "flex-start",
    "gap": "10px",
    "margin-left": "5px",
    "font-size": "12px"
  }
};
const _hoisted_28 = {
  key: 0
};
const _hoisted_29 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "margin-left": "20px"
  }
};
const _hoisted_30 = {
  style: {
    "font-weight": "bold",
    "line-height": "25px",
    "font-size": "14px"
  }
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1"
  }
}, null, -1));
const _hoisted_32 = {
  key: 0,
  style: {
    "display": "flex",
    "font-size": "14px"
  }
};
const _hoisted_33 = {
  key: 1
};
const _hoisted_34 = {
  style: {
    "display": "flex",
    "font-size": "12px",
    "margin-left": "20px",
    "flex": "1",
    "overflow-y": "auto"
  }
};
const _hoisted_35 = {
  border: "0",
  style: {
    "width": "100%",
    "text-align": "left",
    "font-family": "sans-serif"
  }
};
const _hoisted_36 = {
  style: {
    "line-height": "25px",
    "font-size": "12px"
  }
};
const _hoisted_37 = {
  style: {
    "line-height": "25px",
    "font-size": "12px"
  }
};
const _hoisted_38 = {
  style: {
    "line-height": "25px",
    "font-size": "12px"
  }
};
const _hoisted_39 = {
  style: {
    "line-height": "25px",
    "font-size": "12px"
  }
};
const _hoisted_40 = {
  style: {
    "line-height": "25px",
    "font-size": "12px"
  }
};
const _hoisted_41 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "flex": "1",
    "margin-left": "10px"
  }
};
const _hoisted_42 = {
  style: {
    "flex": "1",
    "position": "relative",
    "display": "flex",
    "align-items": "center",
    "justify-content": "center",
    "border": "1px solid black",
    "margin-right": "10px"
  }
};
const _hoisted_43 = {
  key: 0
};
const _hoisted_44 = {
  style: {
    "width": "24px",
    "height": "24px",
    "background-color": "#00a5fa",
    "border-radius": "50%",
    "bottom": "90px",
    "right": "30px",
    "position": "absolute",
    "display": "flex",
    "align-items": "center",
    "justify-content": "center",
    "cursor": "pointer"
  }
};
const _hoisted_45 = {
  style: {
    "display": "flex",
    "margin-top": "10px",
    "height": "209px"
  }
};
const _hoisted_46 = {
  style: {
    "flex": "1",
    "display": "flex",
    "flex-direction": "column"
  }
};
const _hoisted_47 = {
  style: {
    "display": "flex",
    "overflow": "hidden"
  }
};
const _hoisted_48 = ["onClick"];
const _hoisted_49 = {
  style: {
    "display": "flex",
    "overflow": "hidden"
  }
};
const _hoisted_50 = ["onClick"];
const _hoisted_51 = {
  style: {
    "display": "flex",
    "overflow": "hidden"
  }
};
const _hoisted_52 = ["onClick"];
const _hoisted_53 = {
  style: {
    "display": "flex",
    "overflow": "hidden"
  }
};
const _hoisted_54 = ["onClick"];
const _hoisted_55 = {
  style: {
    "display": "flex",
    "overflow": "hidden"
  }
};
const _hoisted_56 = ["onClick"];
const _hoisted_57 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_58 = {
  style: {
    "white-space": "nowrap",
    "overflow": "hidden",
    "text-overflow": "ellipsis"
  }
};
const _hoisted_59 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "width": "120px"
  }
};
const _hoisted_60 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "flex": "1",
    "overflow": "hidden",
    "font-size": "14px",
    "color": "#777777",
    "padding": "0px 20px"
  }
};
const _hoisted_61 = {
  style: {
    "display": "flex",
    "height": "35px",
    "align-items": "center",
    "background-color": "#7D7D7D",
    "color": "#fff"
  }
};
const _hoisted_62 = {
  style: {
    "min-width": "60px",
    "text-align": "center"
  }
};
const _hoisted_63 = {
  style: {
    "text-align": "center",
    "min-width": "180px"
  }
};
const _hoisted_64 = {
  style: {
    "width": "300px"
  }
};
const _hoisted_65 = {
  style: {
    "width": "200px"
  }
};
const _hoisted_66 = {
  style: {
    "flex": "1",
    "margin-left": "5px",
    "max-width": "468px",
    "min-width": "468px"
  }
};
const _hoisted_67 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "flex": "1",
    "overflow-y": "auto",
    "position": "relative"
  }
};
const _hoisted_68 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "position": "absolute",
    "inset": "0px"
  }
};
const _hoisted_69 = {
  style: {
    "min-width": "60px",
    "text-align": "center"
  }
};
const _hoisted_70 = {
  style: {
    "min-width": "180px",
    "display": "flex",
    "flex-direction": "column",
    "border-radius": "4px",
    "align-items": "center"
  }
};
const _hoisted_71 = {
  style: {
    "display": "flex",
    "width": "300px"
  }
};
const _hoisted_72 = {
  border: "0",
  style: {
    "width": "100%",
    "text-align": "left",
    "font-family": "sans-serif"
  }
};
const _hoisted_73 = {
  style: {
    "line-height": "25px",
    "font-size": "12px"
  }
};
const _hoisted_74 = {
  style: {
    "line-height": "25px",
    "font-size": "12px"
  }
};
const _hoisted_75 = {
  style: {
    "line-height": "25px",
    "font-size": "12px"
  }
};
const _hoisted_76 = {
  style: {
    "line-height": "25px",
    "font-size": "12px"
  }
};
const _hoisted_77 = {
  style: {
    "line-height": "25px",
    "font-size": "12px"
  }
};
const _hoisted_78 = {
  style: {
    "width": "200px"
  }
};
const _hoisted_79 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "align-items": "start",
    "max-width": "468px",
    "min-width": "468px",
    "height": "155px"
  }
};
const _hoisted_80 = {
  key: 0,
  class: "tabBox"
};
const _hoisted_81 = ["onClick"];
const _hoisted_82 = {
  style: {
    "display": "flex",
    "align-items": "start"
  }
};
const _hoisted_83 = {
  style: {
    "display": "flex",
    "margin-top": "5px"
  }
};
const _hoisted_84 = {
  key: 0,
  style: {
    "display": "flex",
    "align-self": "stretch",
    "align-items": "center"
  }
};
const _hoisted_85 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_86 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "flex": "1"
  }
};
const _hoisted_87 = {
  style: {
    "margin-left": "20px",
    "margin-bottom": "20px"
  }
};
const _hoisted_88 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "flex": "1",
    "overflow": "hidden"
  }
};
const _hoisted_89 = {
  style: {
    "display": "flex",
    "flex": "1",
    "color": "#777777"
  }
};
const _hoisted_90 = {
  style: {
    "width": "590px",
    "display": "flex",
    "flex-direction": "column"
  }
};
const _hoisted_91 = {
  style: {
    "display": "flex",
    "justify-content": "space-between"
  }
};
const _hoisted_92 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "margin-left": "20px",
    "width": "352px",
    "height": "264px",
    "min-width": "352px",
    "min-height": "264px"
  }
};
const _hoisted_93 = ["src"];
const _hoisted_94 = {
  key: 2,
  style: {
    "width": "352px",
    "height": "264px",
    "min-width": "352px",
    "min-height": "264px"
  }
};
const _hoisted_95 = {
  style: {
    "width": "205px",
    "height": "280px",
    "overflow-y": "auto",
    "position": "relative"
  }
};
const _hoisted_96 = {
  key: 0,
  style: {
    "position": "absolute",
    "inset": "0",
    "display": "flex",
    "flex-shrink": "0",
    "flex-wrap": "wrap",
    "align-content": "flex-start",
    "align-items": "flex-start",
    "justify-content": "flex-start",
    "gap": "10px",
    "font-size": "12px"
  }
};
const _hoisted_97 = ["onClick", "src"];
const _hoisted_98 = {
  style: {
    "display": "flex",
    "font-size": "12px",
    "margin-left": "20px",
    "height": "209px",
    "overflow-y": "auto"
  }
};
const _hoisted_99 = {
  border: "0",
  style: {
    "width": "100%",
    "text-align": "left",
    "font-family": "sans-serif"
  }
};
const _hoisted_100 = {
  style: {
    "font-weight": "bold",
    "line-height": "25px",
    "font-size": "14px"
  }
};
const _hoisted_101 = {
  style: {
    "line-height": "25px",
    "font-size": "12px"
  }
};
const _hoisted_102 = {
  key: 0,
  style: {
    "display": "inline-block",
    "padding": "0 2px",
    "color": "#fff",
    "background": "#29C93F",
    "border-radius": "5px"
  }
};
const _hoisted_103 = {
  key: 1,
  style: {
    "display": "inline-block",
    "padding": "0 2px",
    "color": "#fff",
    "background": "#FEBD30",
    "border-radius": "5px"
  }
};
const _hoisted_104 = {
  key: 2,
  style: {
    "display": "inline-block",
    "padding": "0 2px",
    "color": "#fff",
    "background": "#FF6057",
    "border-radius": "5px"
  }
};
const _hoisted_105 = {
  style: {
    "line-height": "25px",
    "font-size": "12px"
  }
};
const _hoisted_106 = {
  style: {
    "line-height": "25px",
    "font-size": "12px"
  }
};
const _hoisted_107 = {
  style: {
    "line-height": "25px",
    "font-size": "12px"
  }
};
const _hoisted_108 = {
  style: {
    "font-weight": "bold",
    "line-height": "25px",
    "font-size": "14px"
  }
};
const _hoisted_109 = {
  style: {
    "line-height": "25px",
    "font-size": "12px"
  }
};
const _hoisted_110 = {
  style: {
    "line-height": "25px",
    "font-size": "12px"
  }
};
const _hoisted_111 = {
  style: {
    "line-height": "25px",
    "font-size": "12px"
  }
};
const _hoisted_112 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "flex": "1",
    "margin-left": "10px",
    "overflow": "hidden"
  }
};
const _hoisted_113 = {
  style: {
    "flex": "1",
    "position": "relative",
    "display": "flex",
    "align-items": "center",
    "justify-content": "center",
    "border": "1px solid black",
    "margin-right": "10px"
  }
};
const _hoisted_114 = {
  key: 0
};
const _hoisted_115 = {
  style: {
    "width": "24px",
    "height": "24px",
    "background-color": "#00a5fa",
    "border-radius": "50%",
    "bottom": "90px",
    "right": "30px",
    "position": "absolute",
    "display": "flex",
    "align-items": "center",
    "justify-content": "center",
    "cursor": "pointer"
  }
};
const _hoisted_116 = {
  style: {
    "display": "flex",
    "margin-top": "10px",
    "overflow-x": "auto",
    "height": "209px"
  }
};
const _hoisted_117 = {
  style: {
    "flex": "1",
    "display": "flex",
    "flex-direction": "column"
  }
};
const _hoisted_118 = {
  style: {
    "display": "flex",
    "overflow": "hidden"
  }
};
const _hoisted_119 = ["onClick"];
const _hoisted_120 = {
  style: {
    "display": "flex",
    "overflow": "hidden",
    "width": "100%",
    "flex-wrap": "wrap"
  }
};
const _hoisted_121 = ["onClick"];
const _hoisted_122 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_123 = {
  style: {
    "white-space": "nowrap",
    "overflow": "hidden",
    "text-overflow": "ellipsis"
  }
};
const _hoisted_124 = {
  style: {
    "display": "flex",
    "overflow": "hidden",
    "width": "100%",
    "flex-wrap": "wrap"
  }
};
const _hoisted_125 = ["onClick"];
const _hoisted_126 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_127 = {
  style: {
    "white-space": "nowrap",
    "overflow": "hidden",
    "text-overflow": "ellipsis"
  }
};
const _hoisted_128 = {
  style: {
    "display": "flex",
    "overflow": "hidden",
    "width": "100%",
    "flex-wrap": "wrap"
  }
};
const _hoisted_129 = ["onClick"];
const _hoisted_130 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_131 = {
  style: {
    "white-space": "nowrap",
    "overflow": "hidden",
    "text-overflow": "ellipsis"
  }
};
const _hoisted_132 = {
  style: {
    "display": "flex",
    "overflow": "hidden",
    "width": "100%",
    "flex-wrap": "wrap"
  }
};
const _hoisted_133 = ["onClick"];
const _hoisted_134 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_135 = {
  style: {
    "white-space": "nowrap",
    "overflow": "hidden",
    "text-overflow": "ellipsis"
  }
};
const _hoisted_136 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "flex": "1",
    "overflow": "hidden",
    "font-size": "14px",
    "color": "#777777",
    "padding": "0px 20px"
  }
};
const _hoisted_137 = {
  style: {
    "display": "flex",
    "height": "35px",
    "align-items": "center",
    "background-color": "#7D7D7D",
    "color": "#fff"
  }
};
const _hoisted_138 = {
  style: {
    "width": "60px",
    "text-align": "center",
    "min-width": "60px"
  }
};
const _hoisted_139 = {
  style: {
    "width": "200px",
    "min-width": "200px"
  }
};
const _hoisted_140 = {
  style: {
    "width": "350px",
    "min-width": "350px"
  }
};
const _hoisted_141 = {
  style: {
    "width": "200px",
    "min-width": "200px"
  }
};
const _hoisted_142 = {
  style: {
    "width": "200px",
    "min-width": "200px"
  }
};
const _hoisted_143 = {
  style: {
    "width": "468px",
    "max-width": "468px"
  }
};
const _hoisted_144 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "flex": "1",
    "overflow-y": "auto",
    "position": "relative"
  }
};
const _hoisted_145 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "position": "absolute",
    "inset": "0px"
  }
};
const _hoisted_146 = {
  style: {
    "width": "60px",
    "text-align": "center",
    "min-width": "60px"
  }
};
const _hoisted_147 = {
  style: {
    "width": "200px",
    "min-width": "200px"
  }
};
const _hoisted_148 = {
  style: {
    "display": "flex",
    "width": "350px",
    "min-width": "350px",
    "flex-direction": "column",
    "gap": "10px"
  }
};
const _hoisted_149 = {
  border: "0",
  style: {
    "width": "100%",
    "text-align": "left",
    "font-family": "sans-serif"
  }
};
const _hoisted_150 = {
  style: {
    "line-height": "25px",
    "font-size": "12px"
  }
};
const _hoisted_151 = {
  key: 0,
  style: {
    "display": "inline-block",
    "padding": "0 2px",
    "color": "#fff",
    "background": "#29C93F",
    "border-radius": "5px"
  }
};
const _hoisted_152 = {
  key: 1,
  style: {
    "display": "inline-block",
    "padding": "0 2px",
    "color": "#fff",
    "background": "#FEBD30",
    "border-radius": "5px"
  }
};
const _hoisted_153 = {
  key: 2,
  style: {
    "display": "inline-block",
    "padding": "0 2px",
    "color": "#fff",
    "background": "#FF6057",
    "border-radius": "5px"
  }
};
const _hoisted_154 = {
  style: {
    "line-height": "25px",
    "font-size": "12px"
  }
};
const _hoisted_155 = {
  style: {
    "line-height": "25px",
    "font-size": "12px"
  }
};
const _hoisted_156 = {
  style: {
    "line-height": "25px",
    "font-size": "12px"
  }
};
const _hoisted_157 = {
  style: {
    "display": "flex",
    "width": "200px",
    "min-width": "200px",
    "flex-direction": "column",
    "gap": "10px"
  }
};
const _hoisted_158 = {
  border: "0",
  style: {
    "width": "100%",
    "text-align": "left",
    "font-family": "sans-serif"
  }
};
const _hoisted_159 = {
  style: {
    "line-height": "25px",
    "font-size": "12px"
  }
};
const _hoisted_160 = {
  style: {
    "line-height": "25px",
    "font-size": "12px"
  }
};
const _hoisted_161 = {
  style: {
    "line-height": "25px",
    "font-size": "12px"
  }
};
const _hoisted_162 = {
  style: {
    "display": "flex",
    "width": "200px",
    "min-width": "200px",
    "flex-direction": "column",
    "gap": "10px"
  }
};
const _hoisted_163 = {
  border: "0",
  style: {
    "width": "100%",
    "text-align": "left",
    "font-family": "sans-serif"
  }
};
const _hoisted_164 = {
  style: {
    "line-height": "25px",
    "font-size": "12px"
  }
};
const _hoisted_165 = {
  style: {
    "line-height": "25px",
    "font-size": "12px"
  }
};
const _hoisted_166 = {
  style: {
    "line-height": "25px",
    "font-size": "12px"
  }
};
const _hoisted_167 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "height": "100%",
    "width": "100%",
    "overflow-x": "auto"
  }
};
const _hoisted_168 = ["src", "onClick"];
const _hoisted_169 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_170 = {
  style: {
    "padding": "0px 5px",
    "background-color": "#676a6d",
    "color": "white",
    "border-radius": "4px"
  }
};
const _hoisted_171 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1"
  }
}, null, -1));
const _hoisted_172 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "width": "100%",
    "height": "433px",
    "position": "relative",
    "border": "1px solid black"
  }
};
const _hoisted_173 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_174 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "X：", -1));
const _hoisted_175 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Y：", -1));
const _hoisted_176 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1"
  }
}, null, -1));
const _hoisted_177 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_178 = {
  style: {
    "width": "100px"
  }
};
const _hoisted_179 = {
  style: {
    "position": "absolute",
    "text-align": "center",
    "right": "30px"
  }
};
const _hoisted_180 = ["src"];
const _hoisted_181 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_182 = {
  style: {
    "margin-bottom": "20px"
  }
};
const _hoisted_183 = {
  style: {
    "text-align": "center"
  }
};
const _hoisted_184 = ["src"];
const _hoisted_185 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bottom"
}, null, -1));
const _hoisted_186 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "QRtitle"
}, null, -1));
const _hoisted_187 = {
  class: "copyQR"
};
const _hoisted_188 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_189 = {
  style: {
    "padding": "0px 5px",
    "background-color": "#676a6d",
    "color": "white",
    "border-radius": "4px"
  }
};
const _hoisted_190 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1"
  }
}, null, -1));
const _hoisted_191 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "width": "100%",
    "height": "433px",
    "position": "relative",
    "border": "1px solid black"
  }
};
const _hoisted_192 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_193 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "X：", -1));
const _hoisted_194 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Y：", -1));
const _hoisted_195 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1"
  }
}, null, -1));
const _hoisted_196 = {
  style: {
    "height": "500px",
    "text-align": "center"
  }
};
const _hoisted_197 = ["src"];
import { ref, reactive, onMounted, getCurrentInstance, h, nextTick, createVNode, computed, onBeforeUnmount, watch } from "vue";
import util from "@/util/util";
import permission from "@/util/permission";
import { Modal, message } from "ant-design-vue";
import { DownCircleOutlined, PlusOutlined, ExclamationCircleOutlined } from "@ant-design/icons-vue";
import ResizePane from "@/components/ResizePane.vue";
import dayjs from "dayjs";
import { useRouter, useRoute } from "vue-router";
import MapWithMarkers from "../components/MapWithMarkers.vue";
import showConfirmModal from "@/util//showConfirmModal";
import html2canvas from "html2canvas";
import { v4 as uuidv4 } from "uuid";
import { Plus } from "@element-plus/icons-vue";
import { useI18n } from "vue-i18n";

import { ElNotification, ElMessageBox, ElMessage } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/notification/style/css';
import 'element-plus/es/components/message-box/style/css';
import 'element-plus/es/components/message/style/css';
export default {
  __name: 'StoreLocation',
  setup(__props) {
    const {
      t,
      locale
    } = useI18n(); // 获取 locale 引用
    const {
      proxy
    } = getCurrentInstance();
    const router = useRouter();
    const route = useRoute();
    const code = route.params.storeCode;
    const paramsLoactionId = route.params.locationId;
    console.log('paramsLoactionId:' + paramsLoactionId);
    const installationId = route.query.installationId;
    const activityId = route.query.activityId;
    const isScreen = route.query.isScreen;
    const dataTabsKey = ref("1");
    const imageryTabModel = ref(1);
    const imageryScreenTabModel = ref(1);
    const QRcodeVisible = ref(false);
    const QRcodeBox = ref(null);
    const QRcodeMsg = reactive({});
    const wxCodeImage = ref(null);
    const pointLocationSummaryIndex = ref(null);
    const repairOpenVisible = ref(false);
    const repairEditFormData = ref({
      repairUrgent: 1
    });
    const repairEditForm = ref(null);
    const videoOpen = ref(false);
    const noDaoju = ref(false);
    const videoUrl = ref('');
    let imageryTabModelJson = JSON.parse(window.localStorage.getItem("imagery_tab_model") || '{"value":1}');
    const storeLocationTreeProps = {
      value: "storeLocationId",
      label: "locationName",
      children: "locations"
    };
    imageryTabModel.value = imageryTabModelJson.value;
    const storeLocationData = reactive({
      treeData: {},
      listData: [],
      floorData: [],
      treeOptionData: [],
      locationsByStoreLocationId: {},
      props: {
        label: "locationName",
        children: "locations"
      }
    });
    const screenStoreLocationData = reactive({
      treeData: [],
      listData: [],
      floorData: [],
      indexData: []
    });
    const controlScreenStoreLocationData = reactive({
      current: {},
      currentStoreLocation: {},
      currentVideo: {},
      currentFloor: null,
      locationLabel: null,
      tab: {
        tabIndex: [0, 0, 0, 0, 0],
        tabData: new Array(5)
      }
    });
    const controlData = reactive({
      tab: {
        tabIndex: new Array(5),
        tabData: new Array(5)
      },
      locationInfo: null,
      currentUploadedInfo: null,
      currentFloor: null,
      locationLabel: null
    });
    const getPreferredUploadedInfo = uploadedInfo => {
      if (!Array.isArray(uploadedInfo) || uploadedInfo.length === 0) {
        return null;
      }
      return uploadedInfo.find(item => item.activityInstallationUploadStatusId === 1) || uploadedInfo[0];
    };
    const initialPoints = computed(() => {
      if (controlData.currentFloor != null) {
        return controlData.currentFloor.storeFloorPoints.map(floor => ({
          id: floor.storeFloorPointId,
          x: floor.pointX,
          y: floor.pointY
        }));
      }
      return [];
    });
    const preViewVideo = async name => {
      videoOpen.value = true;
      console.log(name);
      videoUrl.value = name;
    };
    const initialScreenPoints = computed(() => {
      if (controlScreenStoreLocationData.currentFloor != null && Array.isArray(controlScreenStoreLocationData.currentFloor.storeFloorPoints)) {
        return controlScreenStoreLocationData.currentFloor.storeFloorPoints.map(floor => ({
          id: floor.storeFloorPointId,
          x: floor.pointX,
          y: floor.pointY
        }));
      }
      return [];
    });
    const findPath = async (data, targetId, path = []) => {
      for (let i = 0; i < data.length; i++) {
        const item = data[i];
        if (item.locations) {
          const newPath = [...path, i];
          const result = await findPath(item.locations, targetId, newPath); // ✅加await
          if (result) return result;
        }
        if (item.storeLocationId == targetId) {
          return [...path, i];
        }
      }
      return null;
    };
    onMounted(async () => {
      const storeLocationRO = {
        storeCode: code,
        installationId: installationId,
        activityId: activityId
      };
      let daoju = await getStoreLocation(storeLocationRO);
      console.log(daoju);
      storeLocationData;
      storeLocationData.treeData = daoju;
      console.log(daoju.storeFloors);
      await getStoreFloor(code);
      if (permission.havePermission("屏幕管理", "查看")) {
        await getScreenStoreFloor(code);
        await getOldScreenStoreLocation(code);
        await getScreenStoreLocation(code);
      }
      if (daoju.storeFloors.length !== 0) {
        changeTab(0, 0);
      } else {
        noDaoju.value = true;
      }
      if (isScreen == 2) {
        dataTabsKey.value = '2';
        if (paramsLoactionId != 0) {
          if (paramsLoactionId != 0) {
            let data = screenStoreLocationData.screenStoreLocationData.storeFloors;
            console.log(data, paramsLoactionId);
            let path = await findPath(data, paramsLoactionId);
            console.log('path');
            console.log(path);
            changeStoreLocationScreen(path);
          }
        }
      } else {
        dataTabsKey.value = '1';
        if (paramsLoactionId != 0) {
          let data = storeLocationData.treeData.storeFloors;
          console.log(data);
        }
      }
    });
    const addDisableProperty = data => {
      // 深拷贝数据，避免修改原始数据
      const copyData = JSON.parse(JSON.stringify(data));
      const updateData = (arr, parentPath) => {
        if (!parentPath) {
          parentPath = "";
        }
        return arr.map(item => {
          // 给当前对象添加 disable: true
          if (!item.storeLocationId) {
            item.disabled = true;
            item.storeLocationId = uuidv4();
            item.fullPath = "";
          } else {
            item.fullPath = parentPath.substring(1) + "/" + item.locationName;
          }

          // 如果有 children，递归调用
          if (item.locations && item.locations.length > 0) {
            item.locations = updateData(item.locations, parentPath + "/" + item.locationName);
          }
          return item;
        });
      };
      return updateData(copyData);
    };
    const changeTab = (activeTabIndex, level) => {
      controlData.tab.tabIndex[level] = activeTabIndex;
      for (let i = level + 1; i < 5; i++) {
        controlData.tab.tabIndex[i] = 0;
      }
      onChangeTabData(storeLocationData.treeData.storeFloors, 0);
    };
    const onChangeTabData = (data, level) => {
      console.log(data, level);
      if (level == 5) {
        controlData.locationInfo = controlData.tab.tabData[4][controlData.tab.tabIndex[4]];
        controlData.currentUploadedInfo = getPreferredUploadedInfo(controlData.locationInfo.uploadedInfo);
        if (controlData.currentFloor && Array.isArray(controlData.currentFloor.storeFloorPoints)) {
          let findLocation = storeLocationData.listData.find(item => item.storeLocationId === controlData.locationInfo.storeLocationId);
          pointLocationSummaryIndex.value = null;
          let findIndex = controlData.currentFloor.storeFloorPoints.findIndex(item => item.storeFloor === findLocation.floor && item.category === findLocation.category && item.region === findLocation.region && item.location === findLocation.location && item.locationSummary === null);
          if (findIndex !== -1) {
            pointLocationSummaryIndex.value = 3;
            selectPoint(controlData.currentFloor.storeFloorPoints[findIndex].storeFloorPointId);
          } else {
            findIndex = controlData.currentFloor.storeFloorPoints.findIndex(item => item.storeFloor === findLocation.floor && item.category === findLocation.category && item.region === findLocation.region && item.location === findLocation.location && item.locationSummary === findLocation.locationSummary);
            if (findIndex != -1) {
              pointLocationSummaryIndex.value = 4;
              selectPoint(controlData.currentFloor.storeFloorPoints[findIndex].storeFloorPointId);
            } else {
              selectId.value = null;
            }
          }
        }
        console.log(controlData.locationInfo);
        return;
      }
      controlData.tab.tabData[level] = data;
      if (level === 0) {
        let floorList = storeLocationData.floorData.filter(item => item.storeFloor === data[controlData.tab.tabIndex[level]].locationName);
        if (Array.isArray(floorList) && floorList.length > 0) {
          if (controlData.currentFloor !== floorList[0]) {
            controlData.currentFloor = floorList[0];
          }
        }
      }
      onChangeTabData(data[controlData.tab.tabIndex[level]].locations, level + 1);
    };
    const onChangeTabByStoreLocation = storeLocation => {};
    const onPreviewChange = item => {
      controlData.currentUploadedInfo = item;
    };

    //获取店铺位置
    const getStoreLocation = async code => {
      return new Promise((resolve, reject) => {
        proxy.$api.storeRequest.getStoreLocation(code, true).then(res => {
          if (res.code === "200000") {
            if (res.result.dataCode === "202104") {
              //没有点位信息返回
              if (res.result.data.storeFloors.length === 0) {
                // ElNotification({
                //   title: "error",
                //   message: t("storeLocation.noPoints"),
                //   type: "error",
                //   duration: 3000,
                // });
                // router.go(-1);
                resolve(res.result.data);
              } else {
                storeLocationData.treeData = res.result.data;
                repairEditFormData.value.storeName = storeLocationData.treeData.storeName;
                repairEditFormData.value.storeCode = storeLocationData.treeData.storeCode;
                if (Array.isArray(res.result.data.storeFloors)) {
                  storeLocationData.treeOptionData = addDisableProperty(res.result.data.storeFloors);
                  storeLocationData.treeOptionData.push({
                    locationName: "其它",
                    storeLocationId: 0
                  });
                }
                //排序
                let customOrder = ["Primary Story", "RN", "BB", "Liftstyle", "Training", "Bra & Leggings", "YA", "JORDAN", "NBY", "JBY", "365"];
                for (let i = 0; i < storeLocationData.treeData.storeFloors.length; i++) {
                  let arr = storeLocationData.treeData.storeFloors[i].locations;
                  arr.sort((a, b) => {
                    const indexA = customOrder.indexOf(a.locationName);
                    const indexB = customOrder.indexOf(b.locationName);
                    return indexA - indexB; // 升序排序，如果需要降序，则改为 `return indexB - indexA;`
                  });
                }

                storeLocationData.listData.length = 0;
                if (Array.isArray(storeLocationData.treeData.storeFloors)) {
                  for (let storeFloor of storeLocationData.treeData.storeFloors) {
                    if (Array.isArray(storeFloor.locations)) {
                      for (let location1 of storeFloor.locations) {
                        if (Array.isArray(location1.locations)) {
                          for (let location2 of location1.locations) {
                            if (Array.isArray(location2.locations)) {
                              for (let location3 of location2.locations) {
                                if (Array.isArray(location3.locations)) {
                                  for (let location4 of location3.locations) {
                                    const locationLabel = storeFloor.locationName + "-" + location1.locationName + "-" + location2.locationName + "-" + location3.locationName + "-" + location4.locationName;
                                    const locationObject = {
                                      locationLabel: locationLabel,
                                      activityName: location4.activityName,
                                      activityId: location4.activityId,
                                      floor: storeFloor.locationName,
                                      category: location1.locationName,
                                      region: location2.locationName,
                                      location: location3.locationName,
                                      locationSummary: location4.locationName,
                                      supportType: location4.supportType,
                                      ice: location4.ice,
                                      gender: location4.gender,
                                      locationDescription: location4.locationDescription,
                                      quantity: location4.quantity,
                                      materialAndCraft: location4.materialAndCraft,
                                      sizeDescription: location4.sizeDescription,
                                      width: location4.width,
                                      height: location4.height,
                                      storeLocationId: location4.storeLocationId,
                                      installationStatusId: location4.installationStatusId,
                                      originalUploaded: [],
                                      uploaded: [],
                                      activityVendors: location4.activityVendors,
                                      vendorTabIndex: 0
                                    };
                                    storeLocationData.listData.push(locationObject);
                                    if (Array.isArray(location4.uploadedInfo)) {
                                      for (let info of location4.uploadedInfo) {
                                        locationObject.uploaded.push(info);
                                      }
                                    }
                                    if (activityId) {
                                      for (let vendor of locationObject.activityVendors) {
                                        const filteredVendorArray = locationObject.uploaded.filter(function (element) {
                                          return element.vendorId === vendor.vendorId;
                                        });
                                        if (filteredVendorArray.length == 0) {
                                          vendor.isEmpty = true;
                                        } else {
                                          for (let upload of filteredVendorArray) {
                                            upload.vendorName = vendor.vendorName;
                                          }
                                        }
                                      }
                                      locationObject.originalUploaded = locationObject.uploaded;
                                      vendorTabBarChange(locationObject, 0);
                                    }
                                    storeLocationData.locationsByStoreLocationId[location4.storeLocationId] = locationObject;
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
                resolve(res.result.data);
              }
            } else {
              ElNotification({
                title: "error",
                message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
                type: "error",
                duration: 3000
              });
              resolve(null);
            }
          } else {
            ElNotification({
              title: "error",
              message: res.msg,
              type: "error",
              duration: 3000
            });
            resolve(null);
          }
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    //获取店铺楼层
    const getStoreFloor = async storeCode => {
      return new Promise((resolve, reject) => {
        proxy.$api.storeRequest.getStoreFloor(storeCode, true).then(res => {
          if (res.code === "200000") {
            if (res.result.dataCode === "202120") {
              let floorData = res.result.data;
              storeLocationData.floorData.length = 1;
              if (Array.isArray(floorData)) {
                for (let floor of floorData) {
                  let floorPoints = [];
                  if (Array.isArray(floor.storeFloorPoints)) {
                    for (let point of floor.storeFloorPoints) {
                      let findIndex = storeLocationData.listData.findIndex(item => item.floor === point.storeFloor && item.category === point.category && item.region === point.region && item.location === point.location);
                      if (findIndex != -1) {
                        floorPoints.push(point);
                      }
                    }
                  }
                  floor.storeFloorPoints = floorPoints;
                  storeLocationData.floorData.push(floor);
                }
              }
              resolve(res.result.data);
            } else {
              ElNotification({
                title: "error",
                message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
                type: "error",
                duration: 3000
              });
              resolve(null);
            }
          } else {
            ElNotification({
              title: "error",
              message: res.msg,
              type: "error",
              duration: 3000
            });
            resolve(null);
          }
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };

    //获取店铺楼层
    const getScreenStoreFloor = async storeCode => {
      return new Promise((resolve, reject) => {
        proxy.$api.screenRequest.getStoreFloor(storeCode, true).then(res => {
          if (res.code === "200000") {
            if (res.result.dataCode === "202120") {
              let floorData = res.result.data;
              screenStoreLocationData.floorData = floorData;
              resolve(floorData);
            } else {
              ElNotification({
                title: "error",
                message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
                type: "error",
                duration: 3000
              });
              resolve(null);
            }
          } else {
            ElNotification({
              title: "error",
              message: res.msg,
              type: "error",
              duration: 3000
            });
            resolve(null);
          }
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const getScreenStoreLocation = async code => {
      return new Promise((resolve, reject) => {
        proxy.$api.screenRequest.getScreenStoreLocation(code, true).then(res => {
          if (res.code === "200000") {
            console.log(res);
            if (res.result.dataCode === "202504") {
              screenStoreLocationData.screenStoreLocationData = res.result.data;
              // debugger;
              // if (Array.isArray(screenStoreLocationData.listData)) {
              //   for (const screen of screenStoreLocationData.listData) {
              //     const findIndex = screenStoreLocationData.treeData.findIndex(
              //       (item) => item.storeFloor === screen.storeFloor
              //     );
              //     if (findIndex === -1) {
              //       screenStoreLocationData.treeData.push({
              //         storeFloor: screen.storeFloor,
              //         children: [screen],
              //       });
              //     } else {
              //       screenStoreLocationData.treeData[findIndex].children.push(
              //         screen
              //       );
              //     }
              //   }
              //   if (screenStoreLocationData.listData.length > 0) {
              //     controlScreenStoreLocationData.current =
              //       screenStoreLocationData.treeData[0];
              //     changeStoreFoor(
              //       controlScreenStoreLocationData.current.children[0].storeFloor
              //     );
              //   }
              // }
              resolve(res.result.data);
            } else {
              ElNotification({
                title: "error",
                message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
                type: "error",
                duration: 3000
              });
              resolve(null);
            }
          } else {
            ElNotification({
              title: "error",
              message: res.msg,
              type: "error",
              duration: 3000
            });
            resolve(null);
          }
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const getOldScreenStoreLocation = async code => {
      return new Promise((resolve, reject) => {
        proxy.$api.screenRequest.getOldScreenStoreLocation(code, true).then(res => {
          if (res.code === "200000") {
            if (res.result.dataCode === "202504") {
              screenStoreLocationData.listData = res.result.data;
              // debugger;
              if (Array.isArray(screenStoreLocationData.listData)) {
                for (const screen of screenStoreLocationData.listData) {
                  const findIndex = screenStoreLocationData.treeData.findIndex(item => item.storeFloor === screen.storeFloor);
                  if (findIndex === -1) {
                    screenStoreLocationData.treeData.push({
                      storeFloor: screen.storeFloor,
                      children: [screen]
                    });
                  } else {
                    screenStoreLocationData.treeData[findIndex].children.push(screen);
                  }
                }
                if (screenStoreLocationData.listData.length > 0) {
                  controlScreenStoreLocationData.current = screenStoreLocationData.treeData[0];
                  changeStoreFoor(controlScreenStoreLocationData.current.children[0].storeFloor);
                }
              }
              resolve(res.result.data);
            } else {
              ElNotification({
                title: "error",
                message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
                type: "error",
                duration: 3000
              });
              resolve(null);
            }
          } else {
            ElNotification({
              title: "error",
              message: res.msg,
              type: "error",
              duration: 3000
            });
            resolve(null);
          }
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const vendorTabBarChange = (locationObject, index) => {
      let vendor = locationObject.activityVendors[index];
      locationObject.uploaded = locationObject.originalUploaded.filter(function (element) {
        return element.vendorId === vendor.vendorId;
      });
    };
    const approvedUploadedAll = () => {
      ElMessageBox.confirm(t("storeLocation.confirmApproveAll"), t("storeLocation.ask"), {
        confirmButtonText: t("storeLocation.confirm"),
        cancelButtonText: t("storeLocation.cancel"),
        type: "warning"
      }).then(() => {
        let activityInstallationApprovedRO = {
          installationId: installationId
        };
        approvedActivityInstallationUploadedAllRequest(activityInstallationApprovedRO);
      }).catch(() => {
        ElMessage({
          type: "info",
          message: t("storeLocation.confirmCancel")
        });
      });
    };
    const approvedUploaded = uploaded => {
      ElMessageBox.confirm(t("storeLocation.confirmApproveAll"), t("storeLocation.ask"), {
        confirmButtonText: t("storeLocation.confirm"),
        cancelButtonText: t("storeLocation.cancel"),
        type: "warning"
      }).then(() => {
        approvedActivityInstallationUploadedRequest(uploaded);
      }).catch(() => {
        ElMessage({
          type: "info",
          message: t("storeLocation.confirmCancel")
        });
      });
    };
    const nullifiedUploaded = uploaded => {
      ElMessageBox.confirm(t("storeLocation.confirmInvalidatePhotos"), t("storeLocation.ask"), {
        confirmButtonText: t("storeLocation.confirm"),
        cancelButtonText: t("storeLocation.cancel"),
        type: "warning"
      }).then(() => {
        nullifiedActivityInstallationUploadedRequest(uploaded);
      }).catch(() => {
        ElMessage({
          type: "info",
          message: t("storeLocation.confirmCancel")
        });
      });
    };
    const approvedActivityInstallationUploadedAllRequest = async activityInstallationApprovedRO => {
      proxy.$api.activityRequest.approvedActivityInstallationUploadedAll(activityInstallationApprovedRO).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "202173") {
            if (Array.isArray(storeLocationData.treeData.storeFloors)) {
              for (let storeFloor of storeLocationData.treeData.storeFloors) {
                if (Array.isArray(storeFloor.locations)) {
                  for (let location1 of storeFloor.locations) {
                    if (Array.isArray(location1.locations)) {
                      for (let location2 of location1.locations) {
                        if (Array.isArray(location2.locations)) {
                          for (let location3 of location2.locations) {
                            if (Array.isArray(location3.locations)) {
                              for (let location4 of location3.locations) {
                                if (Array.isArray(location4.uploadedInfo)) {
                                  for (let info of location4.uploadedInfo) {
                                    info.activityInstallationUploadStatusId = 2;
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            storeLocationData.treeData.storeLocationStatusId = 2;
            ElNotification({
              title: "success",
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "success",
              duration: 3000
            });
          } else {
            ElNotification({
              title: "error",
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "error",
              duration: 6000
            });
          }
        } else {
          ElNotification({
            title: "error",
            message: res.msg,
            type: "error",
            duration: 6000
          });
        }
      }).catch(error => {
        ElNotification({
          title: "error",
          message: error,
          type: "error",
          duration: 3000
        });
      });
    };
    const approvedActivityInstallationUploadedRequest = async uploaded => {
      let activityInstallationUploadedApprovedRO = {
        activityInstallationToUploadId: uploaded.activityInstallationToUploadId
      };
      proxy.$api.activityRequest.approvedActivityInstallationUploaded(activityInstallationUploadedApprovedRO).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "202173") {
            uploaded.activityInstallationUploadStatusId = 2;
            controlData.currentUploadedInfo = getPreferredUploadedInfo(controlData.locationInfo?.uploadedInfo);
            ElNotification({
              title: "success",
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "success",
              duration: 3000
            });
          } else {
            ElNotification({
              title: "error",
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "error",
              duration: 6000
            });
          }
        } else {
          ElNotification({
            title: "error",
            message: res.msg,
            type: "error",
            duration: 6000
          });
        }
      }).catch(error => {
        ElNotification({
          title: "error",
          message: error,
          type: "error",
          duration: 3000
        });
      });
    };
    const nullifiedActivityInstallationUploadedRequest = async uploaded => {
      let activityInstallationUploadedNullifieRO = {
        activityInstallationToUploadId: uploaded.activityInstallationToUploadId
      };
      proxy.$api.activityRequest.nullifiedActivityInstallationUploaded(activityInstallationUploadedNullifieRO).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "202184") {
            uploaded.activityInstallationUploadStatusId = 3;
            controlData.currentUploadedInfo = getPreferredUploadedInfo(controlData.locationInfo?.uploadedInfo);
            ElNotification({
              title: "success",
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "success",
              duration: 3000
            });
          } else {
            ElNotification({
              title: "error",
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "error",
              duration: 6000
            });
          }
        } else {
          ElNotification({
            title: "error",
            message: res.msg,
            type: "error",
            duration: 6000
          });
        }
      }).catch(error => {
        ElNotification({
          title: "error",
          message: error,
          type: "error",
          duration: 3000
        });
      });
    };
    const activeTabsKeyChange = activityKey => {
      segmentedValue1.value = 'view';
      segmentedValue2.value = 'view';
    };
    const onImageryTabChangeModel = () => {
      if (imageryTabModel.value === 1) {
        imageryTabModel.value = 2;
      } else {
        imageryTabModel.value = 1;
      }
      window.localStorage.setItem("imagery_tab_model", JSON.stringify({
        value: imageryTabModel.value
      }));
    };
    const onImageryScreenTabChangeModel = () => {
      if (imageryScreenTabModel.value === 1) {
        imageryScreenTabModel.value = 2;
      } else {
        imageryScreenTabModel.value = 1;
      }
    };
    const uploadActivityPhotoData = reactive({
      signatureData: {
        accessId: null,
        policy: null,
        signature: null,
        dir: null,
        host: "",
        expire: null,
        uuid: null
      },
      fileList: [],
      data: {},
      lastUpload: {},
      file: {
        url: null
      }
    });
    const getSignature = async directory => {
      return new Promise((resolve, reject) => {
        proxy.$api.authorizationRequest.getSignature(directory).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          console.log(error);
          reject(error);
        });
      });
    };
    const uploadActivityPhoto = ref(null);
    const handleActivityPhotoBeforeUpload = async (file, storeLocationId) => {
      uploadActivityPhotoData.signatureData = await getSignature("__temporary");
      let filename = file.name;
      let fullName = uploadActivityPhotoData.signatureData.uuid + util.getSuffix(filename);
      let keyValue = uploadActivityPhotoData.signatureData.dir + fullName;
      const uploadData = {
        name: file.name,
        key: keyValue,
        policy: uploadActivityPhotoData.signatureData.policy,
        OSSAccessKeyId: uploadActivityPhotoData.signatureData.accessId,
        signature: uploadActivityPhotoData.signatureData.signature,
        success_action_status: "200",
        onSuccess: file.uid,
        param: {
          storeLocationId: storeLocationId
        }
      };
      uploadActivityPhotoData.data = uploadData;
      file.uploadData = uploadData;
    };
    const handleActivityPhotoExceed = files => {
      // uploadActivityPhoto.value.clearFiles();
      // const file = files[0];
      // file.uid = genFileId();
      // uploadActivityPhoto.value.handleStart(file);
      // uploadActivityPhoto.value.submit();
    };
    const handleActivityPhotoOnSuccess = async (response, file, files) => {
      if (file.status === "success") {
        let uploadData = file.raw.uploadData;
        let activityInstallationPhotoUploadRO = {
          installationId: installationId,
          storeLocationId: uploadData.param.storeLocationId,
          uploadedRO: {
            fileName: uploadData.name,
            uploadedName: uploadData.key
          }
        };
        uploadActivityInstallationPhotoRequest(activityInstallationPhotoUploadRO);
      }
    };
    const uploadActivityInstallationPhotoRequest = async activityInstallationPhotoUploadRO => {
      proxy.$api.repairRequest.uploadActivityInstallationPhoto(activityInstallationPhotoUploadRO).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "202266") {
            let uploaded = res.result.data;
            storeLocationData.locationsByStoreLocationId[uploaded.storeLocationId].uploaded.unshift(uploaded);
            if (Array.isArray(storeLocationData.treeData.storeFloors)) {
              for (let storeFloor of storeLocationData.treeData.storeFloors) {
                if (Array.isArray(storeFloor.locations)) {
                  for (let location1 of storeFloor.locations) {
                    if (Array.isArray(location1.locations)) {
                      for (let location2 of location1.locations) {
                        if (Array.isArray(location2.locations)) {
                          for (let location3 of location2.locations) {
                            if (Array.isArray(location3.locations)) {
                              for (let location4 of location3.locations) {
                                if (location4.storeLocationId == uploaded.storeLocationId) {
                                  if (!Array.isArray(location4.uploadedInfo)) {
                                    location4.uploadedInfo = [];
                                  }
                                  location4.uploadedInfo.unshift(uploaded);
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            ElNotification({
              title: "success",
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "success",
              duration: 3000
            });
          } else {
            ElNotification({
              title: "error",
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "error",
              duration: 6000
            });
          }
        } else {
          ElNotification({
            title: "error",
            message: res.msg,
            type: "error",
            duration: 6000
          });
        }
      }).catch(error => {
        if (error.code == "TOKEN_MISSING") {
          resolve(null);
        } else {
          ElNotification({
            title: "error",
            message: error,
            type: "error",
            duration: 3000
          });
        }
      });
    };
    const uploadFloorMapData = reactive({
      signatureData: {
        accessId: null,
        policy: null,
        signature: null,
        dir: null,
        host: "",
        expire: null,
        uuid: null
      },
      fileList: [],
      data: {},
      lastUpload: {},
      file: {
        url: null
      }
    });
    const uploadFloorMap = ref(null);
    const handleFloorMapBeforeUpload = async file => {
      uploadFloorMapData.signatureData = await getSignature("__temporary");
      let filename = file.name;
      let fullName = uploadFloorMapData.signatureData.uuid + util.getSuffix(filename);
      let keyValue = uploadFloorMapData.signatureData.dir + fullName;
      const uploadData = {
        name: file.name,
        key: keyValue,
        policy: uploadFloorMapData.signatureData.policy,
        OSSAccessKeyId: uploadFloorMapData.signatureData.accessId,
        signature: uploadFloorMapData.signatureData.signature,
        success_action_status: "200",
        onSuccess: file.uid
      };
      uploadFloorMapData.data = uploadData;
      file.uploadData = uploadData;
    };
    const handleFloorMapBeforeExceed = files => {};
    const handleFloorMapBeforeOnSuccess = async (response, file, files) => {
      if (file.status === "success") {
        let uploadData = file.raw.uploadData;
        let floorMapUploadedRO = {
          storeCode: code,
          storeFloor: controlData.currentFloor.storeFloor,
          uploadedRO: {
            fileName: uploadData.name,
            uploadedName: uploadData.key
          }
        };
        uploadFloorMapRequest(floorMapUploadedRO);
      }
    };
    const uploadFloorMapRequest = async floorMapUploadedRO => {
      proxy.$api.storeRequest.uploadFloorMap(floorMapUploadedRO).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "202122") {
            let uploaded = res.result.data;
            controlData.currentFloor.storeFloorMap = uploaded.storeFloorMap;
          } else {
            ElNotification({
              title: "error",
              message: res.msg,
              type: "error",
              duration: 6000
            });
          }
        }
      }).catch(error => {
        if (error.code == "TOKEN_MISSING") {
          resolve(null);
        } else {
          ElNotification({
            title: "error",
            message: error,
            type: "error",
            duration: 3000
          });
        }
      });
    };
    const removeFloorMapRequest = async floorMapRemoveRO => {
      proxy.$api.storeRequest.removeFloorMap(floorMapRemoveRO).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "202129") {
            let uploaded = res.result.data;
            controlData.currentFloor.storeFloorMap = uploaded.storeFloorMap;
          } else {
            ElNotification({
              title: "error",
              message: res.msg,
              type: "error",
              duration: 6000
            });
          }
        }
      }).catch(error => {
        if (error.code == "TOKEN_MISSING") {
          resolve(null);
        } else {
          ElNotification({
            title: "error",
            message: error,
            type: "error",
            duration: 3000
          });
        }
      });
    };
    const floorMapRef = ref(null);
    const selectId = ref(null);
    const handleFloorPointSelected = id => {
      let point = controlData.currentFloor.storeFloorPoints.find(item => item.storeFloorPointId === id);
      let location = null;
      if (point.locationSummary === null) {
        location = storeLocationData.listData.find(item => item.floor === point.storeFloor && item.category === point.category && item.region === point.region && item.location === point.location);
      } else {
        location = storeLocationData.listData.find(item => item.floor === point.storeFloor && item.category === point.category && item.region === point.region && item.location === point.location && item.locationSummary === point.locationSummary);
      }
      if (location) {
        let findIndex = controlData.tab.tabData[0].findIndex(item => item.locationName === location.floor);
        controlData.tab.tabIndex[0] = findIndex;
        controlData.tab.tabData[1] = controlData.tab.tabData[0][findIndex].locations;
        findIndex = controlData.tab.tabData[1].findIndex(item => item.locationName === location.category);
        controlData.tab.tabIndex[1] = findIndex;
        controlData.tab.tabData[2] = controlData.tab.tabData[1][findIndex].locations;
        findIndex = controlData.tab.tabData[2].findIndex(item => item.locationName === location.region);
        controlData.tab.tabIndex[2] = findIndex;
        controlData.tab.tabData[3] = controlData.tab.tabData[2][findIndex].locations;
        findIndex = controlData.tab.tabData[3].findIndex(item => item.locationName === location.location);
        controlData.tab.tabIndex[3] = findIndex;
        controlData.tab.tabData[4] = controlData.tab.tabData[3][findIndex].locations;
        findIndex = controlData.tab.tabData[4].findIndex(item => item.locationName === location.locationSummary);
        controlData.tab.tabIndex[4] = findIndex;
        onChangeTabData(controlData.tab.tabData[4], 5);
      }
      console.log("Selected point ID:", id);
    };
    const selectPoint = id => {
      selectId.value = id;
      // if (floorMapRef.value) {
      //   floorMapRef.value.selectPointById(id);
      // }
    };

    const clearPoint = () => {
      showConfirmModal({
        title: t("storeLocation.tip"),
        content: t("storeLocation.confirmDeletePoint"),
        okText: t("storeLocation.clear"),
        cancelText: t("storeLocation.cancel"),
        onOk: () => {
          dialogFloorMapRef.value.clearSelectPoint();
          dialogControlData.x = null;
          dialogControlData.y = null;
        }
      });
    };
    const onFloorMapOpen = async isLocationSummary => {
      if (isLocationSummary === true || pointLocationSummaryIndex.value === 4) {
        currentIsLocationSummary.value = true;
      } else {
        currentIsLocationSummary.value = null;
        if (locationPointHaveEdit() === false) {
          return;
        }
      }
      let location = storeLocationData.listData.find(item => item.storeLocationId === controlData.locationInfo.storeLocationId);
      controlData.locationLabel = location.locationLabel;
      floorMapOpen.value = true;
      dialogControlData.points = controlData.currentFloor.storeFloorPoints.map(floor => ({
        id: floor.storeFloorPointId,
        x: floor.pointX,
        y: floor.pointY
      }));
      await nextTick();
      const point = controlData.currentFloor.storeFloorPoints.find(p => p.storeFloorPointId === selectId.value);
      if (point) {
        dialogControlData.x = point.pointX;
        dialogControlData.y = point.pointY;
        dialogFloorMapRef.value.enterEditMode(point.storeFloorPointId);
      } else {
        dialogControlData.x = null;
        dialogControlData.y = null;
        dialogFloorMapRef.value.enterEditMode(null);
      }
    };
    const onFloorMapRemove = async () => {
      showConfirmModal({
        title: t("storeLocation.tip"),
        content: t("storeLocation.confirmRemoveFloor"),
        okText: t("storeLocation.clear"),
        cancelText: t("storeLocation.cancel"),
        onOk: () => {
          let floorMapRemoveRO = {
            storeCode: code,
            storeFloor: controlData.currentFloor.storeFloor
          };
          removeFloorMapRequest(floorMapRemoveRO);
        }
      });
    };
    const dialogFloorMapRef = ref(null);
    const floorMapOpen = ref(false);
    const dialogControlData = reactive({
      points: [],
      x: null,
      y: null
    });
    const handleDialogFloorPointSelected = id => {
      console.log("Selected point ID:", id);
    };
    const handleDialogFloorPointChanged = (x, y) => {
      dialogControlData.x = x;
      dialogControlData.y = y;
    };
    const onSavePoint = () => {
      let point = dialogFloorMapRef.value.getSelectPoint();
      let findLocation = storeLocationData.listData.find(item => item.storeLocationId === controlData.locationInfo.storeLocationId);
      if (point.id == -1 && point.x == -30) {
        floorMapOpen.value = false;
      } else if (point.id != -1 && point.x == -30) {
        let deleteFloorPointRO = {
          storeCode: code,
          storeFloor: findLocation.floor,
          category: findLocation.category,
          category: findLocation.category,
          region: findLocation.region,
          location: findLocation.location,
          locationSummary: currentIsLocationSummary.value === true ? findLocation.locationSummary : null,
          storeLocationId: controlData.locationInfo.storeLocationId
        };
        deleteFloorPointRequest(deleteFloorPointRO, point.id);
      } else {
        let updateFloorPointRO = {
          storeCode: code,
          storeFloor: findLocation.floor,
          category: findLocation.category,
          category: findLocation.category,
          region: findLocation.region,
          location: findLocation.location,
          locationSummary: currentIsLocationSummary.value === true ? findLocation.locationSummary : null,
          pointX: point.x,
          pointY: point.y,
          storeLocationId: controlData.locationInfo.storeLocationId
        };
        updateFloorPointRequest(updateFloorPointRO, point.id);
      }
      console.log("point:", point);
    };
    const updateFloorPointRequest = async (updateFloorPointRO, id) => {
      proxy.$api.storeRequest.updateFloorPoint(updateFloorPointRO).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "202123") {
            let point = res.result.data;
            if (point.locationSummary === null) {
              pointLocationSummaryIndex.value = 3;
            } else if (point.locationSummary !== null) {
              pointLocationSummaryIndex.value = 4;
            }
            if (id == -1) {
              controlData.currentFloor.storeFloorPoints.push(point);
              selectPoint(point.storeFloorPointId);
            } else {
              controlData.currentFloor.storeFloorPoints = controlData.currentFloor.storeFloorPoints.map(item => {
                if (item.storeFloor === point.storeFloor && item.category === point.category && item.region === point.region && item.location === point.location && item.locationSummary === point.locationSummary) {
                  Object.assign(item, point); // 直接更新对象的属性
                }

                return item;
              });
            }
            floorMapOpen.value = false;
            ElNotification({
              title: "success",
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "success",
              duration: 3000
            });
          } else {
            ElNotification({
              title: "error",
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "error",
              duration: 6000
            });
          }
        } else {
          ElNotification({
            title: "error",
            message: res.msg,
            type: "error",
            duration: 6000
          });
        }
      }).catch(error => {
        ElNotification({
          title: "error",
          message: error,
          type: "error",
          duration: 3000
        });
      });
    };
    const deleteFloorPointRequest = async (deleteFloorPointRO, id) => {
      proxy.$api.storeRequest.deleteFloorPoint(deleteFloorPointRO).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "202125") {
            controlData.currentFloor.storeFloorPoints = controlData.currentFloor.storeFloorPoints.filter(item => {
              return item.storeFloorPointId !== id;
            });
            pointLocationSummaryIndex.value = null;
            floorMapOpen.value = false;
            ElNotification({
              title: "success",
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "success",
              duration: 3000
            });
          } else {
            ElNotification({
              title: "error",
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "error",
              duration: 6000
            });
          }
        } else {
          ElNotification({
            title: "error",
            message: res.msg,
            type: "error",
            duration: 6000
          });
        }
      }).catch(error => {
        ElNotification({
          title: "error",
          message: error,
          type: "error",
          duration: 3000
        });
      });
    };
    const onActivityRepair = () => {
      uploadTableData.fileList.length = 0;
      uploadTableData.uploadedList.length = 0;
      repairEditFormData.repairUrgent = 1;
      repairEditFormData.storeLocationId = null;
      repairEditFormData.reporterName = null;
      repairEditFormData.reporterMobile = null;
      repairEditFormData.reporterDescription = null;
      let location = storeLocationData.listData.find(item => item.storeLocationId === controlData.locationInfo.storeLocationId);
      let activityRepairWxCodeRO = {
        locationName: location.locationLabel,
        storeLocationId: location.storeLocationId,
        storeName: storeLocationData.treeData.storeName,
        storeCode: code
      };
      activityRepairWxCodeRequest(activityRepairWxCodeRO);
    };
    const activityRepairWxCodeRequest = activityRepairWxCodeRO => {
      proxy.$api.wxRequest.getActivityRepairWxCode(activityRepairWxCodeRO).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "200000") {
            wxCodeImage.value = res.result.data;
            // QRcodeVisible.value = true;
            repairOpenVisible.value = true;
          } else {
            ElNotification({
              title: "error",
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "error",
              duration: 6000
            });
          }
        } else {
          ElNotification({
            title: "error",
            message: res.msg,
            type: "error",
            duration: 6000
          });
        }
      }).catch(error => {
        if (error.code == "TOKEN_MISSING") {
          resolve(null);
        } else {
          ElNotification({
            title: "error",
            message: error,
            type: "error",
            duration: 3000
          });
        }
      });
    };

    //二维码复制
    const copyQrcode = () => {
      html2canvas(QRcodeBox.value, {
        useCORS: true,
        // 【重要】开启跨域配置
        allowTaint: true // 允许跨域图片
      }).then(canvas => {
        canvas.toBlob(blob => {
          const data = [new ClipboardItem({
            [blob.type]: blob
          })];
          navigator.clipboard.write(data).then(() => {
            ElNotification({
              title: "success",
              message: t("storeLocation.copiedToClipboard"),
              type: "success",
              duration: 3000
            });
          }, () => {
            ElNotification({
              title: "error",
              message: t("storeLocation.copyFail"),
              type: "error",
              duration: 3000
            });
          });
        }, "image/png");
      });
    };
    const currentIsLocationSummary = ref(null);
    const onAddPoint = (event, index) => {
      event.stopPropagation();
      changeTab(index, 4);
      onFloorMapOpen(true);
    };
    const onAddScreenPoint = (event, location) => {
      event.stopPropagation();
      changeStoreLocation(location);
      onScreenFloorMapOpen(true);
    };
    const changeStoreFoor = (storeFloor, index) => {
      console.log(storeFloor, index);
      controlScreenStoreLocationData.tab.tabIndex[1] = 0;
      controlScreenStoreLocationData.tab.tabIndex[2] = 0;
      controlScreenStoreLocationData.tab.tabIndex[3] = 0;
      controlScreenStoreLocationData.tab.tabIndex[4] = 0;
      if (index != null) {
        controlScreenStoreLocationData.tab.tabIndex[0] = index;
      } else {
        controlScreenStoreLocationData.tab.tabIndex[0] = 0;
      }
      const findIndex = screenStoreLocationData.treeData.findIndex(item => item.storeFloor === storeFloor);
      if (findIndex !== -1) {
        controlScreenStoreLocationData.current = screenStoreLocationData.treeData[findIndex];
        controlScreenStoreLocationData.currentStoreLocation = screenStoreLocationData.treeData[findIndex].children[0];
        if (controlScreenStoreLocationData.currentStoreLocation.videos.length > 0) {
          controlScreenStoreLocationData.currentVideo = controlScreenStoreLocationData.currentStoreLocation.videos[0];
        }
        const floorIndex = screenStoreLocationData.floorData.findIndex(item => item.storeFloor === controlScreenStoreLocationData.currentStoreLocation.storeFloor);
        if (floorIndex != -1) {
          controlScreenStoreLocationData.currentFloor = screenStoreLocationData.floorData[floorIndex];
          if (Array.isArray(controlScreenStoreLocationData.currentFloor.storeFloorPoints)) {
            const storeLocationIndex = controlScreenStoreLocationData.currentFloor.storeFloorPoints.findIndex(item => item.storeLocationId === controlScreenStoreLocationData.currentStoreLocation.storeLocationId);
            if (storeLocationIndex != -1) {
              selectScreenPoint(controlScreenStoreLocationData.currentFloor.storeFloorPoints[storeLocationIndex].storeFloorPointId);
            } else {
              selectScreenPoint(null);
            }
          } else {
            selectScreenPoint(null);
          }
        } else {
          controlScreenStoreLocationData.currentFloor = null;
          selectScreenPoint(null);
        }
      }
    };
    const changeStoreLocation = (storeLocation, index, classIndex) => {
      if (classIndex === 1) {
        controlScreenStoreLocationData.tab.tabIndex[2] = 0;
        controlScreenStoreLocationData.tab.tabIndex[3] = 0;
        controlScreenStoreLocationData.tab.tabIndex[4] = 0;
      }
      if (classIndex === 2) {
        controlScreenStoreLocationData.tab.tabIndex[3] = 0;
        controlScreenStoreLocationData.tab.tabIndex[4] = 0;
      }
      if (classIndex === 3) {
        controlScreenStoreLocationData.tab.tabIndex[4] = 0;
      }
      // console.log(storeLocation,index,classIndex)
      controlScreenStoreLocationData.tab.tabIndex[classIndex] = index;
      //------

      controlScreenStoreLocationData.currentStoreLocation = screenStoreLocationData.screenStoreLocationData.storeFloors[controlScreenStoreLocationData.tab.tabIndex[0]].locations[controlScreenStoreLocationData.tab.tabIndex[1]].locations[controlScreenStoreLocationData.tab.tabIndex[2]].locations[controlScreenStoreLocationData.tab.tabIndex[3]].locations[controlScreenStoreLocationData.tab.tabIndex[4]];
      if (controlScreenStoreLocationData.currentStoreLocation.videos == null) {
        controlScreenStoreLocationData.currentStoreLocation.videos = [];
      }
      if (controlScreenStoreLocationData.currentStoreLocation.videos.length > 0) {
        controlScreenStoreLocationData.currentVideo = controlScreenStoreLocationData.currentStoreLocation.videos[0];
      }
      if (controlScreenStoreLocationData.currentFloor && Array.isArray(controlScreenStoreLocationData.currentFloor.storeFloorPoints)) {
        const storeLocationIndex = controlScreenStoreLocationData.currentFloor.storeFloorPoints.findIndex(item => item.storeLocationId === controlScreenStoreLocationData.currentStoreLocation.storeLocationId);
        if (storeLocationIndex != -1) {
          selectScreenPoint(controlScreenStoreLocationData.currentFloor.storeFloorPoints[storeLocationIndex].storeFloorPointId);
        } else {
          selectScreenPoint(null);
        }
      } else {
        selectScreenPoint(null);
      }
    };
    const changeStoreLocationScreen = tabIndex => {
      controlScreenStoreLocationData.tab.tabIndex = tabIndex;
      controlScreenStoreLocationData.currentStoreLocation = screenStoreLocationData.screenStoreLocationData.storeFloors[controlScreenStoreLocationData.tab.tabIndex[0]].locations[controlScreenStoreLocationData.tab.tabIndex[1]].locations[controlScreenStoreLocationData.tab.tabIndex[2]].locations[controlScreenStoreLocationData.tab.tabIndex[3]].locations[controlScreenStoreLocationData.tab.tabIndex[4]];
      if (controlScreenStoreLocationData.currentStoreLocation.videos == null) {
        controlScreenStoreLocationData.currentStoreLocation.videos = [];
      }
      if (controlScreenStoreLocationData.currentStoreLocation.videos.length > 0) {
        controlScreenStoreLocationData.currentVideo = controlScreenStoreLocationData.currentStoreLocation.videos[0];
      }
      if (controlScreenStoreLocationData.currentFloor && Array.isArray(controlScreenStoreLocationData.currentFloor.storeFloorPoints)) {
        const storeLocationIndex = controlScreenStoreLocationData.currentFloor.storeFloorPoints.findIndex(item => item.storeLocationId === controlScreenStoreLocationData.currentStoreLocation.storeLocationId);
        if (storeLocationIndex != -1) {
          selectScreenPoint(controlScreenStoreLocationData.currentFloor.storeFloorPoints[storeLocationIndex].storeFloorPointId);
        } else {
          selectScreenPoint(null);
        }
      } else {
        selectScreenPoint(null);
      }
    };
    const findStorePath = (data, targetId, path = []) => {
      for (let i = 0; i < data.length; i++) {
        const item = data[i];
        if (item.storeLocationId === targetId) return [...path, i];
        if (item.locations && Array.isArray(item.locations)) {
          const result = findStorePath(item.locations, targetId, [...path, i]);
          if (result) return result;
        }
      }
      return null;
    };
    const handleScreenFloorPointSelected = id => {
      let point = controlScreenStoreLocationData.currentFloor.storeFloorPoints.find(item => item.storeFloorPointId === id);
      const storeLocation = screenStoreLocationData.listData.find(item => item.storeLocationId === point.storeLocationId);
      let storeFloor = screenStoreLocationData.screenStoreLocationData.storeFloors;
      let path = findStorePath(storeFloor, storeLocation.storeLocationId);
      console.log(path); // 👉 [0, 0, 0, 0, 2] 
      if (path != null) {
        controlScreenStoreLocationData.tab.tabIndex = path;
        changeStoreLocation(storeLocation);
      }
    };
    const onPreviewVideoChange = video => {
      controlScreenStoreLocationData.currentVideo = video;
    };
    const locationSummaryHaveAdd = location => {
      let storeLocation = storeLocationData.locationsByStoreLocationId[location.storeLocationId];
      let findIndex = controlData.currentFloor.storeFloorPoints.findIndex(item => item.storeFloor === storeLocation.floor && item.category === storeLocation.category && item.region === storeLocation.region && item.location === storeLocation.location && item.locationSummary === null);
      if (findIndex !== -1) {
        return false;
      } else {
        findIndex = controlData.currentFloor.storeFloorPoints.findIndex(item => item.storeFloor === storeLocation.floor && item.category === storeLocation.category && item.region === storeLocation.region && item.location === storeLocation.location && item.locationSummary === storeLocation.locationSummary);
        if (findIndex != -1) {
          return false;
        }
      }
      return true;
    };
    const locationScreenHaveAdd = location => {
      const screenLocation = screenStoreLocationData.floorData.find(item => item.storeCode === location.storeCode && item.storeFloor === location.storeFloor);
      if (screenLocation) {
        if (Array.isArray(screenLocation.storeFloorPoints)) {
          const point = screenLocation.storeFloorPoints.find(item => item.storeLocationId === location.storeLocationId);
          if (point) {
            return false;
          }
        }
      }
      return true;
    };
    const locationPointHaveEdit = () => {
      const point = controlData.currentFloor.storeFloorPoints.find(p => p.storeFloorPointId === selectId.value);
      if (point) {
        return true;
      } else {
        let findLocation = storeLocationData.listData.find(item => item.storeLocationId === controlData.locationInfo.storeLocationId);
        let floors = controlData.currentFloor.storeFloorPoints.filter(item => item.storeFloor === findLocation.floor && item.category === findLocation.category && item.region === findLocation.region && item.location === findLocation.location);
        if (floors.length === 0) {
          return true;
        }
      }
      return false;
    };
    const uploadTable = ref(null);
    const uploadTableData = reactive({
      signatureData: {
        accessId: null,
        policy: null,
        signature: null,
        dir: null,
        host: "",
        expire: null,
        uuid: null
      },
      fileList: [],
      data: {},
      lastUpload: {},
      cacheData: [],
      uploadedList: [],
      repairActivityObj: {}
    });
    const handleRemove = (uploadFile, uploadFiles, index) => {
      console.log(uploadFile, uploadFiles, index);
    };
    const handlePictureCardPreview = uploadFile => {
      dialogImageUrl.value = uploadFile.url;
      dialogVisible.value = true;
    };
    const handleExceed = () => {
      ElNotification({
        title: "error",
        message: t("storeLocation.maxUploadLimit"),
        type: "error",
        duration: 6000
      });
    };
    //文件上传成功的钩子
    const handleStoreOnSuccess = async (response, file) => {
      console.log("file" + file);
      if (file.status === "success") {
        let uploadedRO = {
          fileName: uploadTableData.data.name,
          uploadedName: uploadTableData.data.key,
          uid: file.uid
        };
        uploadTableData.uploadedList.push(uploadedRO);
      }
    };

    //上传文件之前的钩子
    const handleStoreBeforeUpload = async file => {
      uploadTableData.signatureData = await getSignature("__temporary");
      let filename = file.name;
      let fullName = uploadTableData.signatureData.uuid + util.getSuffix(filename);
      let keyValue = uploadTableData.signatureData.dir + fullName;
      uploadTableData.data = {
        name: file.name,
        key: keyValue,
        policy: uploadTableData.signatureData.policy,
        OSSAccessKeyId: uploadTableData.signatureData.accessId,
        signature: uploadTableData.signatureData.signature,
        success_action_status: "200",
        onSuccess: file.uid
      };
      uploadTableData.lastUpload = {
        uid: file.uid,
        filename: fullName
      };
    };
    const onRepairSave = () => {
      repairEditForm.value.validate().then(async () => {
        if (uploadTableData.uploadedList.length === 0) {
          ElNotification({
            title: "error",
            message: t("storeLocation.uploadRepairPhoto"),
            type: "error",
            duration: 3000
          });
          return;
        }
        let formData = JSON.parse(JSON.stringify(repairEditFormData.value));
        let repairAddRO = {
          repairUrgent: formData.repairUrgent,
          reporterDescription: formData.reporterDescription,
          customStoreLocation: formData.customStoreLocation,
          reporterName: formData.reporterName,
          reporterMobile: formData.reporterMobile,
          storeCode: formData.storeCode,
          storeLocationId: formData.storeLocationId,
          uploaded: uploadTableData.uploadedList
        };
        proxy.$api.repairRequest.addRepair(repairAddRO).then(res => {
          if (res.code === "200000") {
            if (res.result.dataCode === "202280") {
              repairEditForm.value.resetFields();
              uploadTable.value.clearFiles();
              ElNotification({
                title: "success",
                message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
                type: "success",
                duration: 3000
              });
            } else {
              ElNotification({
                title: "error",
                message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
                type: "error",
                duration: 6000
              });
            }
            repairOpenVisible.value = false;
          } else {
            ElNotification({
              title: "error",
              message: res.msg,
              type: "error",
              duration: 6000
            });
            repairOpenVisible.value = false;
          }
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "error",
              message: error,
              type: "error",
              duration: 3000
            });
          }
          repairOpenVisible.value = false;
        });
      }).catch(error => {
        console.log("error", error);
      });
    };
    const onRepairCancel = () => {
      repairEditForm.value.resetFields();
      uploadTable.value.clearFiles();
      repairOpenVisible.value = false;
    };
    const customStoreLocationRules = computed(() => {
      if (repairEditFormData.value.storeLocationId === 0) {
        return [{
          required: true,
          message: t("storeLocation.customPoint")
        }];
      }
      return [];
    });
    const repairStoreLocationChange = value => {
      if (value === 0) {} else {
        repairEditFormData.value.customStoreLocation = null;
        repairEditForm.value.clearValidate("customStoreLocation");
      }
    };

    //屏幕楼层地图

    const dialogScreenFloorMapRef = ref(null);
    const screenFloorMapOpen = ref(false);
    const dialogControlScreenData = reactive({
      points: [],
      x: null,
      y: null
    });
    const handleDialogScreenFloorPointSelected = id => {
      console.log("Selected point ID:", id);
    };
    const handleDialogScreenFloorPointChanged = (x, y) => {
      dialogControlScreenData.x = x;
      dialogControlScreenData.y = y;
    };
    const onSaveScreenPoint = () => {
      // debugger;
      let point = dialogScreenFloorMapRef.value.getSelectPoint();
      let findLocation = screenStoreLocationData.listData.find(item => item.storeLocationId === controlScreenStoreLocationData.currentStoreLocation.storeLocationId);
      if (point.id == -1 && point.x == -30) {
        screenFloorMapOpen.value = false;
      } else if (point.id != -1 && point.x == -30) {
        let deleteFloorPointRO = {
          storeCode: code,
          storeFloor: findLocation.storeFloor,
          category: findLocation.category,
          region: findLocation.region,
          location: findLocation.location,
          locationSummary: findLocation.storeLocationName,
          storeLocationId: findLocation.storeLocationId
        };
        deleteScreenFloorPointRequest(deleteFloorPointRO, point.id);
      } else {
        let updateFloorPointRO = {
          storeCode: code,
          storeFloor: findLocation.storeFloor,
          category: findLocation.category,
          region: findLocation.region,
          location: findLocation.location,
          locationSummary: findLocation.storeLocationName,
          pointX: point.x,
          pointY: point.y,
          storeLocationId: findLocation.storeLocationId
        };
        updateScreenFloorPointRequest(updateFloorPointRO, point.id);
      }
      console.log("point:", point);
    };
    const uploadScreenFloorMapData = reactive({
      signatureData: {
        accessId: null,
        policy: null,
        signature: null,
        dir: null,
        host: "",
        expire: null,
        uuid: null
      },
      fileList: [],
      data: {},
      lastUpload: {},
      file: {
        url: null
      }
    });
    const uploadScreenFloorMap = ref(null);
    const handleScreenFloorMapBeforeUpload = async file => {
      uploadScreenFloorMapData.signatureData = await getSignature("__temporary");
      let filename = file.name;
      let fullName = uploadScreenFloorMapData.signatureData.uuid + util.getSuffix(filename);
      let keyValue = uploadScreenFloorMapData.signatureData.dir + fullName;
      const uploadData = {
        name: file.name,
        key: keyValue,
        policy: uploadScreenFloorMapData.signatureData.policy,
        OSSAccessKeyId: uploadScreenFloorMapData.signatureData.accessId,
        signature: uploadScreenFloorMapData.signatureData.signature,
        success_action_status: "200",
        onSuccess: file.uid
      };
      uploadScreenFloorMapData.data = uploadData;
      file.uploadData = uploadData;
    };
    const handleScreenFloorMapBeforeExceed = files => {};
    const handleScreenFloorMapBeforeOnSuccess = async (response, file, files) => {
      if (file.status === "success") {
        let uploadData = file.raw.uploadData;
        let floorMapUploadedRO = {
          storeCode: code,
          storeFloor: controlScreenStoreLocationData.currentFloor ? controlScreenStoreLocationData.currentFloor.storeFloor : controlScreenStoreLocationData.currentStoreLocation.storeFloor,
          uploadedRO: {
            fileName: uploadData.name,
            uploadedName: uploadData.key
          }
        };
        uploadScreenFloorMapRequest(floorMapUploadedRO);
      }
    };
    const uploadScreenFloorMapRequest = async floorMapUploadedRO => {
      proxy.$api.screenRequest.uploadFloorMap(floorMapUploadedRO).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "202122") {
            let uploaded = res.result.data;
            // debugger;
            controlScreenStoreLocationData.currentFloor = uploaded;
            const findIndex = screenStoreLocationData.floorData.findIndex(item => item.storeFloorId === uploaded.storeFloorId);
            if (findIndex === -1) {
              screenStoreLocationData.floorData.push(uploaded);
            } else {
              screenStoreLocationData.floorData[findIndex] = uploaded;
            }
          } else {
            ElNotification({
              title: "error",
              message: res.msg,
              type: "error",
              duration: 6000
            });
          }
        }
      }).catch(error => {
        if (error.code == "TOKEN_MISSING") {
          resolve(null);
        } else {
          ElNotification({
            title: "error",
            message: error,
            type: "error",
            duration: 3000
          });
        }
      });
    };
    const removeScreenFloorMapRequest = async floorMapRemoveRO => {
      proxy.$api.screenRequest.removeFloorMap(floorMapRemoveRO).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "202129") {
            let uploaded = res.result.data;
            // debugger;
            controlScreenStoreLocationData.currentFloor.storeFloorMap = uploaded.storeFloorMap;
          } else {
            ElNotification({
              title: "error",
              message: res.msg,
              type: "error",
              duration: 6000
            });
          }
        }
      }).catch(error => {
        if (error.code == "TOKEN_MISSING") {
          resolve(null);
        } else {
          ElNotification({
            title: "error",
            message: error,
            type: "error",
            duration: 3000
          });
        }
      });
    };
    const onScreenFloorMapRemove = async () => {
      showConfirmModal({
        title: t("storeLocation.tip"),
        content: t("storeLocation.confirmRemoveFloor"),
        okText: t("storeLocation.clear"),
        cancelText: t("storeLocation.cancel"),
        onOk: () => {
          let floorMapRemoveRO = {
            storeCode: code,
            storeFloor: controlScreenStoreLocationData.currentFloor.storeFloor
          };
          removeScreenFloorMapRequest(floorMapRemoveRO);
        }
      });
    };
    const selectScreenPoint = id => {
      screenSelectId.value = id;
    };
    const clearScreenPoint = () => {
      showConfirmModal({
        title: t("storeLocation.tip"),
        content: t("storeLocation.confirmDeletePoint"),
        okText: t("storeLocation.clear"),
        cancelText: t("storeLocation.cancel"),
        onOk: () => {
          dialogScreenFloorMapRef.value.clearSelectPoint();
          dialogControlScreenData.x = null;
          dialogControlScreenData.y = null;
        }
      });
    };
    const onScreenFloorMapOpen = async isLocationSummary => {
      // if (isLocationSummary === true || pointLocationSummaryIndex.value === 4) {
      //   currentIsLocationSummary.value = true;
      // } else {
      //   currentIsLocationSummary.value = null;
      //   if (locationPointHaveEdit() === false) {
      //     return;
      //   }
      // }
      let location = screenStoreLocationData.listData.find(item => item.storeLocationId === controlScreenStoreLocationData.currentStoreLocation.storeLocationId);
      controlScreenStoreLocationData.locationLabel = location.locationLabel;
      screenFloorMapOpen.value = true;
      dialogControlScreenData.points = controlScreenStoreLocationData.currentFloor.storeFloorPoints.map(floor => ({
        id: floor.storeFloorPointId,
        x: floor.pointX,
        y: floor.pointY
      }));
      await nextTick();
      const point = controlScreenStoreLocationData.currentFloor.storeFloorPoints.find(p => p.storeFloorPointId === screenSelectId.value);
      if (point) {
        dialogControlScreenData.x = point.pointX;
        dialogControlScreenData.y = point.pointY;
        dialogScreenFloorMapRef.value.enterEditMode(point.storeFloorPointId);
      } else {
        dialogControlScreenData.x = null;
        dialogControlScreenData.y = null;
        dialogScreenFloorMapRef.value.enterEditMode(null);
      }
    };
    const updateScreenFloorPointRequest = async (updateFloorPointRO, id) => {
      proxy.$api.screenRequest.updateFloorPoint(updateFloorPointRO).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "202123") {
            let point = res.result.data;
            if (id == -1) {
              controlScreenStoreLocationData.currentFloor.storeFloorPoints.push(point);
              selectScreenPoint(point.storeFloorPointId);
            } else {
              controlScreenStoreLocationData.currentFloor.storeFloorPoints = controlScreenStoreLocationData.currentFloor.storeFloorPoints.map(item => {
                if (item.storeLocationId === point.storeLocationId) {
                  Object.assign(item, point); // 直接更新对象的属性
                }

                return item;
              });
            }
            screenFloorMapOpen.value = false;
            ElNotification({
              title: "success",
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "success",
              duration: 3000
            });
          } else {
            ElNotification({
              title: "error",
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "error",
              duration: 6000
            });
          }
        } else {
          ElNotification({
            title: "error",
            message: res.msg,
            type: "error",
            duration: 6000
          });
        }
      }).catch(error => {
        ElNotification({
          title: "error",
          message: error,
          type: "error",
          duration: 3000
        });
      });
    };
    const deleteScreenFloorPointRequest = async (deleteFloorPointRO, id) => {
      proxy.$api.screenRequest.deleteFloorPoint(deleteFloorPointRO).then(res => {
        if (res.code === "200000") {
          if (res.result.dataCode === "202125") {
            controlScreenStoreLocationData.currentFloor.storeFloorPoints = controlScreenStoreLocationData.currentFloor.storeFloorPoints.filter(item => {
              return item.storeFloorPointId !== id;
            });
            // pointLocationSummaryIndex.value = null;
            screenFloorMapOpen.value = false;
            ElNotification({
              title: "success",
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "success",
              duration: 3000
            });
          } else {
            ElNotification({
              title: "error",
              message: locale.value === "zh" ? res.result.promptMsg : res.result.dataMsg,
              type: "error",
              duration: 6000
            });
          }
        } else {
          ElNotification({
            title: "error",
            message: res.msg,
            type: "error",
            duration: 6000
          });
        }
      }).catch(error => {
        ElNotification({
          title: "error",
          message: error,
          type: "error",
          duration: 3000
        });
      });
    };
    const screenFloorMapRef = ref(null);
    const screenSelectId = ref(null);
    const segmentedData1 = computed(() => [{
      label: t('screenManage.view'),
      value: 'view'
    }, {
      label: t('screenManage.list'),
      value: 'list'
    }]);
    const segmentedData2 = computed(() => [{
      label: t('screenManage.view'),
      value: 'view'
    }, {
      label: t('screenManage.list'),
      value: 'list'
    }]);
    const segmentedValue1 = ref('view');
    const segmentedValue2 = ref('view');
    return (_ctx, _cache) => {
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_segmented = _resolveComponent("a-segmented");
      const _component_a_image = _resolveComponent("a-image");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_tag = _resolveComponent("a-tag");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_a_space = _resolveComponent("a-space");
      const _component_a_divider = _resolveComponent("a-divider");
      const _component_a_tab_pane = _resolveComponent("a-tab-pane");
      const _component_a_tabs = _resolveComponent("a-tabs");
      const _component_a_config_provider = _resolveComponent("a-config-provider");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_modal = _resolveComponent("a-modal");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_tree_select = _resolveComponent("a-tree-select");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_textarea = _resolveComponent("a-textarea");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_a_col = _resolveComponent("a-col");
      const _component_a_row = _resolveComponent("a-row");
      const _component_a_form = _resolveComponent("a-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", null, _toDisplayString(storeLocationData.treeData.storeName), 1)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", null, [_createTextVNode(_toDisplayString(_ctx.$t("storeLocation.storeCode")) + ":", 1), _hoisted_6, _createTextVNode(" " + _toDisplayString(storeLocationData.treeData.storeCode), 1)]), _createElementVNode("div", null, [_createTextVNode(_toDisplayString(_ctx.$t("storeLocation.storeType")) + ":", 1), _hoisted_7, _createTextVNode(" " + _toDisplayString(storeLocationData.treeData.storeTypeNameZh), 1)])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", null, [_createTextVNode(_toDisplayString(_ctx.$t("storeLocation.province")) + ":", 1), _hoisted_9, _createTextVNode(_toDisplayString(storeLocationData.treeData.province), 1)]), _createElementVNode("div", null, [_createTextVNode(_toDisplayString(_ctx.$t("storeLocation.city")) + ":", 1), _hoisted_10, _createTextVNode(_toDisplayString(storeLocationData.treeData.city), 1)]), _createElementVNode("div", null, [_createTextVNode(_toDisplayString(_ctx.$t("storeLocation.address")) + ":", 1), _hoisted_11, _createTextVNode(_toDisplayString(storeLocationData.treeData.storeAddress), 1)])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", null, [_createTextVNode(_toDisplayString(_ctx.$t("storeLocation.contact")) + ":", 1), _hoisted_13, _createTextVNode(_toDisplayString(storeLocationData.treeData.contactName), 1)]), _createElementVNode("div", null, [_createTextVNode(_toDisplayString(_ctx.$t("storeLocation.contactMethod")) + ":", 1), _hoisted_14, _createTextVNode(_toDisplayString(storeLocationData.treeData.contactMobile), 1)]), _createElementVNode("div", null, [_createTextVNode(_toDisplayString(_ctx.$t("storeLocation.email")) + ":", 1), _hoisted_15, _createTextVNode(_toDisplayString(storeLocationData.treeData.contactEmail), 1)])])]), _createElementVNode("div", _hoisted_16, [_unref(permission).havePermission('店铺管理', '活动照片审核') && _unref(installationId) != null && _unref(installationId) != '' && storeLocationData.treeData.installationStatusId == 5 ? (_openBlock(), _createBlock(_component_a_button, {
        key: 0,
        onClick: _cache[0] || (_cache[0] = $event => approvedUploadedAll()),
        class: "sts-button default",
        style: {
          "width": "83px",
          "height": "25px",
          "padding": "0",
          "margin-left": "20px",
          "position": "absolute",
          "top": "10px",
          "right": "5px",
          "z-index": "1"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("storeLocation.batchReview")), 1)]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_a_config_provider, {
        theme: {
          components: {
            Tabs: {
              fontSize: 18,
              colorText: '#777777',
              motionDurationMid: 0,
              motionDurationSlow: 0
            }
          }
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_a_tabs, {
          class: "",
          activeKey: dataTabsKey.value,
          "onUpdate:activeKey": _cache[5] || (_cache[5] = $event => dataTabsKey.value = $event),
          animated: false,
          onChange: activeTabsKeyChange
        }, {
          default: _withCtx(() => [_createVNode(_component_a_tab_pane, {
            key: "1",
            disabled: noDaoju.value
          }, {
            tab: _withCtx(() => [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", null, _toDisplayString(_ctx.$t("storeLocation.prop")) + "/" + _toDisplayString(_ctx.$t("storeLocation.layoutDiagram")), 1)])]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createVNode(_component_a_segmented, {
              value: segmentedValue1.value,
              "onUpdate:value": _cache[1] || (_cache[1] = $event => segmentedValue1.value = $event),
              options: segmentedData1.value
            }, null, 8, ["value", "options"])]), _withDirectives(_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [controlData.currentUploadedInfo ? (_openBlock(), _createBlock(_component_a_image, {
              key: 0,
              src: controlData.currentUploadedInfo.url,
              fallback: "https://aqualpublic.oss-cn-shanghai.aliyuncs.com/public/404Big.jpg",
              style: {
                "width": "352px",
                "height": "264px",
                "min-width": "352px",
                "min-height": "264px"
              }
            }, null, 8, ["src"])) : _createCommentVNode("", true), !controlData.currentUploadedInfo ? (_openBlock(), _createElementBlock("div", _hoisted_25)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_26, [controlData.locationInfo ? (_openBlock(), _createElementBlock("div", _hoisted_27, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controlData.locationInfo.uploadedInfo, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                style: {
                  "display": "flex",
                  "flex-direction": "column",
                  "align-items": "center"
                },
                key: index
              }, [_unref(activityId) ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(item.vendorName), 1)) : _createCommentVNode("", true), _createVNode(_component_a_image, {
                style: {
                  "width": "80px",
                  "height": "80px",
                  "cursor": "pointer"
                },
                onClick: $event => onPreviewChange(item),
                class: _normalizeClass([{
                  active: item === controlData.currentUploadedInfo
                }, "preview-image"]),
                src: item.url,
                preview: false,
                fit: "cover",
                fallback: "https://aqualpublic.oss-cn-shanghai.aliyuncs.com/public/404small.jpg"
              }, null, 8, ["onClick", "class", "src"])]);
            }), 128))])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t("storeLocation.propInfo")), 1), _hoisted_31, _unref(activityId) && controlData.locationInfo ? (_openBlock(), _createElementBlock("div", _hoisted_32, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controlData.locationInfo.activityVendors, (data, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index,
                style: {
                  "display": "flex"
                }
              }, [_createElementVNode("div", null, _toDisplayString(data.vendorName), 1), data.isEmpty ? (_openBlock(), _createBlock(_component_svg_icon, {
                key: 0,
                color: "#ff3f22",
                iconName: "Tips",
                iconSize: "12px"
              })) : _createCommentVNode("", true), index < controlData.locationInfo.activityVendors.length - 1 ? (_openBlock(), _createElementBlock("div", _hoisted_33, " / ")) : _createCommentVNode("", true)]);
            }), 128))])) : _createCommentVNode("", true), controlData.currentUploadedInfo && controlData.currentUploadedInfo.activityInstallationUploadStatusId == 1 && _unref(installationId) != null && _unref(installationId) != '' ? (_openBlock(), _createBlock(_component_a_tag, {
              key: 1,
              style: {
                "height": "20px",
                "font-size": "12px"
              },
              color: "orange"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("storeLocation.pendingReview")), 1)]),
              _: 1
            })) : _createCommentVNode("", true), controlData.currentUploadedInfo && controlData.currentUploadedInfo.activityInstallationUploadStatusId == 2 && _unref(installationId) != null && _unref(installationId) != '' ? (_openBlock(), _createBlock(_component_a_tag, {
              key: 2,
              style: {
                "height": "20px",
                "font-size": "12px"
              },
              color: "green"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("storeLocation.approved")), 1)]),
              _: 1
            })) : _createCommentVNode("", true), controlData.currentUploadedInfo && controlData.currentUploadedInfo.activityInstallationUploadStatusId == 3 && _unref(installationId) != null && _unref(installationId) != '' ? (_openBlock(), _createBlock(_component_a_tag, {
              key: 3,
              style: {
                "height": "20px",
                "font-size": "12px"
              },
              color: "red"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("storeLocation.rejected")), 1)]),
              _: 1
            })) : _createCommentVNode("", true), controlData.currentUploadedInfo && controlData.currentUploadedInfo.activityInstallationUploadStatusId == 1 && _unref(installationId) != null && _unref(installationId) != '' && _unref(permission).havePermission('店铺管理', '活动照片审核') && controlData.locationInfo.installationStatusId == 5 ? (_openBlock(), _createBlock(_component_a_button, {
              key: 4,
              style: {
                "height": "25px",
                "padding": "0px 15px"
              },
              onClick: _cache[2] || (_cache[2] = $event => approvedUploaded(controlData.currentUploadedInfo)),
              class: "sts-button green"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("storeLocation.approved")), 1)]),
              _: 1
            })) : _createCommentVNode("", true), controlData.currentUploadedInfo && controlData.currentUploadedInfo.activityInstallationUploadStatusId == 1 && _unref(installationId) != null && _unref(installationId) != '' && _unref(permission).havePermission('店铺管理', '活动照片审核') && controlData.locationInfo.installationStatusId == 5 ? (_openBlock(), _createBlock(_component_a_button, {
              key: 5,
              style: {
                "margin-left": "10px",
                "height": "25px",
                "padding": "0px 15px"
              },
              onClick: _cache[3] || (_cache[3] = $event => nullifiedUploaded(controlData.currentUploadedInfo)),
              class: "sts-button danger"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("storeLocation.rejected")), 1)]),
              _: 1
            })) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_34, [_createElementVNode("table", _hoisted_35, [_createElementVNode("tbody", null, [_createElementVNode("tr", _hoisted_36, [_createElementVNode("td", null, _toDisplayString(_ctx.$t("storeLocation.width")) + "：" + _toDisplayString(controlData.locationInfo && controlData.locationInfo.width), 1), _createElementVNode("td", null, _toDisplayString(_ctx.$t("storeLocation.size")) + "：" + _toDisplayString(controlData.locationInfo && controlData.locationInfo.sizeDescription), 1)]), _createElementVNode("tr", _hoisted_37, [_createElementVNode("td", null, _toDisplayString(_ctx.$t("storeLocation.height")) + "：" + _toDisplayString(controlData.locationInfo && controlData.locationInfo.height), 1), _createElementVNode("td", null, _toDisplayString(_ctx.$t("storeLocation.supportType")) + "：" + _toDisplayString(controlData.locationInfo && controlData.locationInfo.supportType), 1)]), _createElementVNode("tr", _hoisted_38, [_createElementVNode("td", null, _toDisplayString(_ctx.$t("storeLocation.gender")) + "：" + _toDisplayString(controlData.locationInfo && controlData.locationInfo.gender), 1), _createElementVNode("td", null, _toDisplayString(_ctx.$t("storeLocation.positionDesc")) + "：" + _toDisplayString(controlData.locationInfo && controlData.locationInfo.locationDescription), 1)]), _createElementVNode("tr", _hoisted_39, [_createElementVNode("td", null, " ICE：" + _toDisplayString(controlData.locationInfo && controlData.locationInfo.ice), 1), _createElementVNode("td", null, _toDisplayString(_ctx.$t("storeLocation.material")) + "：" + _toDisplayString(controlData.locationInfo && controlData.locationInfo.materialAndCraft), 1)]), _createElementVNode("tr", _hoisted_40, [_createElementVNode("td", null, _toDisplayString(_ctx.$t("storeLocation.quantity")) + "：" + _toDisplayString(controlData.locationInfo && controlData.locationInfo.quantity), 1)])])])])]), _createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_createVNode(MapWithMarkers, {
              ref_key: "floorMapRef",
              ref: floorMapRef,
              imageSrc: controlData.currentFloor ? controlData.currentFloor.storeFloorMap : '',
              selectId: selectId.value,
              initialPoints: initialPoints.value,
              onPointSelected: handleFloorPointSelected
            }, null, 8, ["imageSrc", "selectId", "initialPoints"]), !controlData.currentFloor || !controlData.currentFloor.storeFloorMap ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(_ctx.$t("storeLocation.noFloorPlan")), 1)) : _createCommentVNode("", true), _createVNode(_component_el_upload, {
              class: "logo-upload-box",
              ref_key: "uploadFloorMap",
              ref: uploadFloorMap,
              accept: "image/png, image/jpeg, image/gif, image/jpg",
              "show-file-list": false,
              action: uploadFloorMapData.signatureData.host,
              "before-upload": file => {
                return handleFloorMapBeforeUpload(file);
              },
              "on-success": handleFloorMapBeforeOnSuccess,
              data: uploadFloorMapData.data,
              "on-exceed": handleFloorMapBeforeExceed,
              "file-list": uploadFloorMapData.fileList
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_44, [_createVNode(_component_svg_icon, {
                iconName: "upload",
                iconColor: '#ffffff',
                iconSize: "16px"
              })])]),
              _: 1
            }, 8, ["action", "before-upload", "data", "file-list"]), controlData.currentFloor && controlData.currentFloor.storeFloorMap ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              style: {
                "width": "24px",
                "height": "24px",
                "border-radius": "50%",
                "bottom": "60px",
                "right": "30px",
                "position": "absolute",
                "display": "flex",
                "align-items": "center",
                "justify-content": "center"
              },
              class: _normalizeClass({
                edit_enable: locationPointHaveEdit() === true,
                edit_disable: locationPointHaveEdit() === false
              }),
              onClick: onFloorMapOpen
            }, [_createVNode(_component_svg_icon, {
              iconName: "activityEdit",
              iconColor: '#ffffff',
              iconSize: "16px"
            })], 2)) : _createCommentVNode("", true), controlData.currentFloor && controlData.currentFloor.storeFloorMap ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              style: {
                "width": "24px",
                "height": "24px",
                "background-color": "#fa00a5",
                "border-radius": "50%",
                "bottom": "30px",
                "right": "30px",
                "position": "absolute",
                "display": "flex",
                "align-items": "center",
                "justify-content": "center",
                "cursor": "pointer"
              },
              onClick: onFloorMapRemove
            }, [_createVNode(_component_svg_icon, {
              iconName: "tk_sub",
              iconColor: '#ffffff',
              iconSize: "16px"
            })])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, [_createVNode(_component_a_space, null, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controlData.tab.tabData[0], (location, index) => {
                return _openBlock(), _createElementBlock("div", {
                  class: _normalizeClass([{
                    active: controlData.tab.tabIndex[0] === index
                  }, "filter-button"]),
                  onClick: $event => changeTab(index, 0),
                  key: index
                }, _toDisplayString(location.locationName), 11, _hoisted_48);
              }), 128))]),
              _: 1
            })]), _createVNode(_component_a_divider, {
              style: {
                "margin": "10px 0px",
                "border-block-start": "1px solid #d7d4d4"
              }
            }), _createElementVNode("div", _hoisted_49, [_createVNode(_component_a_space, null, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controlData.tab.tabData[1], (location, index) => {
                return _openBlock(), _createElementBlock("div", {
                  class: _normalizeClass([{
                    active: controlData.tab.tabIndex[1] === index
                  }, "filter-button"]),
                  onClick: $event => changeTab(index, 1),
                  key: index
                }, _toDisplayString(location.locationName), 11, _hoisted_50);
              }), 128))]),
              _: 1
            })]), _createVNode(_component_a_divider, {
              style: {
                "margin": "10px 0px",
                "border-block-start": "1px solid #d7d4d4"
              }
            }), _createElementVNode("div", _hoisted_51, [_createVNode(_component_a_space, null, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controlData.tab.tabData[2], (location, index) => {
                return _openBlock(), _createElementBlock("div", {
                  class: _normalizeClass([{
                    active: controlData.tab.tabIndex[2] === index
                  }, "filter-button"]),
                  onClick: $event => changeTab(index, 2),
                  key: index
                }, _toDisplayString(location.locationName), 11, _hoisted_52);
              }), 128))]),
              _: 1
            })]), _createVNode(_component_a_divider, {
              style: {
                "margin": "10px 0px",
                "border-block-start": "1px solid #d7d4d4"
              }
            }), _createElementVNode("div", _hoisted_53, [_createVNode(_component_a_space, null, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controlData.tab.tabData[3], (location, index) => {
                return _openBlock(), _createElementBlock("div", {
                  class: _normalizeClass([{
                    active_flag: controlData.tab.tabIndex[3] === index && pointLocationSummaryIndex.value === 3,
                    active: controlData.tab.tabIndex[3] === index && pointLocationSummaryIndex.value !== 3
                  }, "filter-button"]),
                  onClick: $event => changeTab(index, 3),
                  key: index
                }, _toDisplayString(location.locationName), 11, _hoisted_54);
              }), 128))]),
              _: 1
            })]), _createVNode(_component_a_divider, {
              style: {
                "margin": "10px 0px",
                "border-block-start": "1px solid #d7d4d4"
              }
            }), _createElementVNode("div", _hoisted_55, [_createVNode(_component_a_space, null, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controlData.tab.tabData[4], (location, index) => {
                return _openBlock(), _createElementBlock("div", {
                  class: _normalizeClass([{
                    active_flag: controlData.tab.tabIndex[4] === index && pointLocationSummaryIndex.value === 4,
                    active: controlData.tab.tabIndex[4] === index && pointLocationSummaryIndex.value !== 4
                  }, "filter-button"]),
                  onClick: $event => changeTab(index, 4),
                  key: index
                }, [_createElementVNode("div", _hoisted_57, [_createElementVNode("div", _hoisted_58, _toDisplayString(location.locationName), 1), locationSummaryHaveAdd(location) === true ? (_openBlock(), _createBlock(_component_svg_icon, {
                  key: 0,
                  style: {
                    "background-color": "rgb(0, 165, 250)",
                    "border-radius": "50%",
                    "margin-left": "3px"
                  },
                  iconName: "add",
                  iconColor: '#ffffff',
                  iconSize: "16px",
                  onClick: $event => onAddPoint($event, index)
                }, null, 8, ["onClick"])) : _createCommentVNode("", true)])], 10, _hoisted_56);
              }), 128))]),
              _: 1
            })])]), _createElementVNode("div", _hoisted_59, [_unref(permission).havePermission('店铺管理', '报修') ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              onClick: onActivityRepair,
              class: "sts-button default",
              style: {
                "width": "83px",
                "height": "25px",
                "padding": "0",
                "margin-left": "20px"
              }
            }, {
              default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("storeLocation.repair")), 1)]),
              _: 1
            })) : _createCommentVNode("", true)])])])])], 512), [[_vShow, segmentedValue1.value === 'view']]), _withDirectives(_createElementVNode("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, [_createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.$t("storeLocation.floor")), 1), _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.$t("storeLocation.point")), 1), _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.$t("storeLocation.propInfo")), 1), _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.$t("storeLocation.activityName")), 1), _createElementVNode("div", _hoisted_66, _toDisplayString(_ctx.$t("storeLocation.image")), 1)]), _createElementVNode("div", _hoisted_67, [_createElementVNode("div", _hoisted_68, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(storeLocationData.listData, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index,
                style: _normalizeStyle([{
                  "display": "flex",
                  "height": "170px",
                  "align-items": "center",
                  "flex-shrink": "0"
                }, {
                  backgroundColor: index % 2 === 0 ? '#ffffff' : '#f9f9f9'
                }])
              }, [_createElementVNode("div", _hoisted_69, _toDisplayString(item.floor), 1), _createElementVNode("div", _hoisted_70, [_createElementVNode("div", null, _toDisplayString(item.category), 1), _createElementVNode("div", null, _toDisplayString(item.region), 1), _createElementVNode("div", null, _toDisplayString(item.location), 1), _createElementVNode("div", null, _toDisplayString(item.locationSummary), 1)]), _createElementVNode("div", _hoisted_71, [_createElementVNode("table", _hoisted_72, [_createElementVNode("tbody", null, [_createElementVNode("tr", _hoisted_73, [_createElementVNode("td", null, _toDisplayString(_ctx.$t("storeLocation.width")) + "：" + _toDisplayString(controlData.locationInfo && controlData.locationInfo.width), 1), _createElementVNode("td", null, _toDisplayString(_ctx.$t("storeLocation.size")) + "：" + _toDisplayString(controlData.locationInfo && controlData.locationInfo.sizeDescription), 1)]), _createElementVNode("tr", _hoisted_74, [_createElementVNode("td", null, _toDisplayString(_ctx.$t("storeLocation.height")) + "：" + _toDisplayString(controlData.locationInfo && controlData.locationInfo.height), 1), _createElementVNode("td", null, _toDisplayString(_ctx.$t("storeLocation.supportType")) + "：" + _toDisplayString(controlData.locationInfo && controlData.locationInfo.supportType), 1)]), _createElementVNode("tr", _hoisted_75, [_createElementVNode("td", null, _toDisplayString(_ctx.$t("storeLocation.gender")) + "：" + _toDisplayString(controlData.locationInfo && controlData.locationInfo.gender), 1), _createElementVNode("td", null, _toDisplayString(_ctx.$t("storeLocation.positionDesc")) + "：" + _toDisplayString(controlData.locationInfo && controlData.locationInfo.locationDescription), 1)]), _createElementVNode("tr", _hoisted_76, [_createElementVNode("td", null, " ICE：" + _toDisplayString(controlData.locationInfo && controlData.locationInfo.ice), 1), _createElementVNode("td", null, _toDisplayString(_ctx.$t("storeLocation.material")) + "：" + _toDisplayString(controlData.locationInfo && controlData.locationInfo.materialAndCraft), 1)]), _createElementVNode("tr", _hoisted_77, [_createElementVNode("td", null, _toDisplayString(_ctx.$t("storeLocation.quantity")) + "：" + _toDisplayString(controlData.locationInfo && controlData.locationInfo.quantity), 1)])])])]), _createElementVNode("div", _hoisted_78, _toDisplayString(item.activityName), 1), _createElementVNode("div", _hoisted_79, [_unref(activityId) ? (_openBlock(), _createElementBlock("div", _hoisted_80, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.activityVendors, (data, index) => {
                return _openBlock(), _createElementBlock("div", {
                  style: {
                    "display": "flex",
                    "align-items": "center"
                  },
                  class: _normalizeClass([{
                    active: index === item.vendorTabIndex
                  }, "filter-button"]),
                  onClick: $event => {
                    item.vendorTabIndex = index;
                    vendorTabBarChange(item, index);
                  },
                  key: index
                }, [_createElementVNode("div", null, _toDisplayString(data.vendorName), 1), data.isEmpty ? (_openBlock(), _createBlock(_component_svg_icon, {
                  key: 0,
                  style: {
                    "margin-left": "3px"
                  },
                  color: "#ff3f22",
                  iconName: "Tips",
                  iconSize: "12px"
                })) : _createCommentVNode("", true)], 10, _hoisted_81);
              }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_82, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.uploaded, (x, index) => {
                return _openBlock(), _createElementBlock("div", {
                  key: index,
                  style: {
                    "display": "flex",
                    "flex-direction": "column",
                    "width": "120px",
                    "margin-left": "5px"
                  }
                }, [_createVNode(_component_a_image, {
                  src: x.url,
                  fit: "cover",
                  style: {
                    "width": "120px",
                    "height": "120px"
                  },
                  fallback: "https://aqualpublic.oss-cn-shanghai.aliyuncs.com/public/404small.jpg"
                }, null, 8, ["src"]), _createElementVNode("div", _hoisted_83, [x.activityInstallationUploadStatusId == 1 && _unref(permission).havePermission('店铺管理', '活动照片审核') && _unref(installationId) != null && _unref(installationId) != '' && item.installationStatusId == 5 ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  onClick: $event => approvedUploaded(x),
                  class: "sts-button default",
                  style: {
                    "width": "60px",
                    "height": "25px",
                    "padding": "0"
                  }
                }, {
                  default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("storeLocation.approved")), 1)]),
                  _: 2
                }, 1032, ["onClick"])) : _createCommentVNode("", true), x.activityInstallationUploadStatusId == 1 && _unref(permission).havePermission('店铺管理', '活动照片审核') && _unref(installationId) != null && _unref(installationId) != '' && item.installationStatusId == 5 ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 1,
                  onClick: $event => nullifiedUploaded(x),
                  class: "sts-button default",
                  style: {
                    "width": "60px",
                    "height": "25px",
                    "padding": "0",
                    "margin-left": "10px"
                  }
                }, {
                  default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("storeLocation.rejected")), 1)]),
                  _: 2
                }, 1032, ["onClick"])) : _createCommentVNode("", true)])]);
              }), 128)), _unref(permission).havePermission('店铺管理', '活动照片审核') && _unref(installationId) != null && _unref(installationId) != '' && item.installationStatusId == 5 ? (_openBlock(), _createElementBlock("div", _hoisted_84, [_createVNode(_component_el_upload, {
                class: "logo-upload-box",
                ref_for: true,
                ref_key: "uploadActivityPhoto",
                ref: uploadActivityPhoto,
                accept: "image/png, image/jpeg, image/gif, image/jpg",
                "show-file-list": false,
                action: uploadActivityPhotoData.signatureData.host,
                "before-upload": file => {
                  return handleActivityPhotoBeforeUpload(file, item.storeLocationId);
                },
                "on-success": handleActivityPhotoOnSuccess,
                data: uploadActivityPhotoData.data,
                "on-exceed": handleActivityPhotoExceed,
                "file-list": uploadActivityPhotoData.fileList,
                multiple: ""
              }, {
                default: _withCtx(() => [uploadActivityPhotoData.file.url === null ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  class: "sts-button default",
                  style: {
                    "width": "83px",
                    "height": "25px",
                    "padding": "0",
                    "margin-left": "10px"
                  }
                }, {
                  default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("storeLocation.addImage")), 1)]),
                  _: 1
                })) : _createCommentVNode("", true)]),
                _: 2
              }, 1032, ["action", "before-upload", "data", "file-list"])])) : _createCommentVNode("", true)])])], 4);
            }), 128))])])], 512), [[_vShow, segmentedValue1.value === 'list']])])]),
            _: 1
          }, 8, ["disabled"]), screenStoreLocationData.listData.length > 0 ? (_openBlock(), _createBlock(_component_a_tab_pane, {
            key: "2"
          }, {
            tab: _withCtx(() => [_createElementVNode("div", _hoisted_85, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('storeLocation.screenLocationMap')), 1)])]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_86, [_createElementVNode("div", _hoisted_87, [_createVNode(_component_a_segmented, {
              value: segmentedValue2.value,
              "onUpdate:value": _cache[4] || (_cache[4] = $event => segmentedValue2.value = $event),
              options: segmentedData2.value
            }, null, 8, ["value", "options"])]), _withDirectives(_createElementVNode("div", _hoisted_88, [_createElementVNode("div", _hoisted_89, [_createElementVNode("div", _hoisted_90, [_createElementVNode("div", _hoisted_91, [_createElementVNode("div", _hoisted_92, [controlScreenStoreLocationData.currentStoreLocation.videos.length === 0 ? (_openBlock(), _createBlock(_component_a_image, {
              key: 0,
              src: "https://aqualpublic.oss-cn-shanghai.aliyuncs.com/public/404Big.jpg",
              style: {
                "width": "352px",
                "height": "264px",
                "min-width": "352px",
                "min-height": "264px"
              }
            })) : _createCommentVNode("", true), controlScreenStoreLocationData.currentStoreLocation.videos.length > 0 ? (_openBlock(), _createElementBlock("video", {
              key: 1,
              autoplay: "",
              loop: "",
              src: controlScreenStoreLocationData.currentVideo.uploadedName,
              style: {
                "width": "352px",
                "height": "264px",
                "min-width": "352px",
                "min-height": "264px"
              },
              controls: ""
            }, null, 8, _hoisted_93)) : _createCommentVNode("", true), !controlData.currentUploadedInfo ? (_openBlock(), _createElementBlock("div", _hoisted_94)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_95, [controlScreenStoreLocationData.currentStoreLocation.videos.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_96, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controlScreenStoreLocationData.currentStoreLocation.videos, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                style: {
                  "display": "flex",
                  "flex-direction": "column",
                  "align-items": "center",
                  "border": "1px solid #dedede"
                },
                key: index
              }, [_createElementVNode("video", {
                style: {
                  "width": "80px",
                  "height": "80px",
                  "cursor": "pointer"
                },
                disablePictureInPicture: "",
                onClick: $event => onPreviewVideoChange(item),
                class: _normalizeClass([{
                  active: item === controlScreenStoreLocationData.currentVideo
                }, "preview-image"]),
                src: item.uploadedName
              }, null, 10, _hoisted_97)]);
            }), 128))])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_98, [_createElementVNode("table", _hoisted_99, [_createElementVNode("tbody", null, [_createElementVNode("tr", _hoisted_100, [_createElementVNode("td", null, _toDisplayString(_ctx.$t('storeLocation.screenInfo')), 1)]), _createElementVNode("tr", _hoisted_101, [_createElementVNode("td", null, [_createTextVNode(_toDisplayString(_ctx.$t('storeLocation.status')) + "： ", 1), controlScreenStoreLocationData.currentStoreLocation.deviceOnlineStatus == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_102, _toDisplayString(_ctx.$t('storeLocation.online')), 1)) : controlScreenStoreLocationData.currentStoreLocation.deviceOnlineStatus == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_103, _toDisplayString(_ctx.$t('storeLocation.offline')), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_104, _toDisplayString(_ctx.$t('storeLocation.disconnected')), 1))]), _createElementVNode("td", null, _toDisplayString(_ctx.$t('storeLocation.actualWidth')) + "：" + _toDisplayString(controlScreenStoreLocationData.currentStoreLocation.actualWidthMm) + "mm ", 1)]), _createElementVNode("tr", _hoisted_105, [_createElementVNode("td", null, _toDisplayString(_ctx.$t('storeLocation.screenType')) + "：" + _toDisplayString(controlScreenStoreLocationData.currentStoreLocation.screenDeviceCategoryName), 1), _createElementVNode("td", null, _toDisplayString(_ctx.$t('storeLocation.actualHeight')) + "：" + _toDisplayString(controlScreenStoreLocationData.currentStoreLocation.actualHeightMm) + "mm ", 1)]), _createElementVNode("tr", _hoisted_106, [_createElementVNode("td", null, _toDisplayString(_ctx.$t('storeLocation.pixelPitch')) + "：" + _toDisplayString(controlScreenStoreLocationData.currentStoreLocation.screenDeviceCategoryName == 'LCD' ? controlScreenStoreLocationData.currentStoreLocation.lcdInch : controlScreenStoreLocationData.currentStoreLocation.dotPitch), 1), _createElementVNode("td", null, _toDisplayString(_ctx.$t('storeLocation.resolution')) + "X：" + _toDisplayString(controlScreenStoreLocationData.currentStoreLocation.resolutionWidth), 1)]), _createElementVNode("tr", _hoisted_107, [_createElementVNode("td", null, _toDisplayString(_ctx.$t('storeLocation.aspectRatio')) + "：" + _toDisplayString(controlScreenStoreLocationData.currentStoreLocation.aspectRatio), 1), _createElementVNode("td", null, _toDisplayString(_ctx.$t('storeLocation.resolution')) + "Y：" + _toDisplayString(controlScreenStoreLocationData.currentStoreLocation.resolutionHeight), 1)]), _createElementVNode("tr", _hoisted_108, [_createElementVNode("td", null, _toDisplayString(_ctx.$t('storeLocation.installationInfo')), 1), _createElementVNode("td", null, _toDisplayString(_ctx.$t('storeLocation.playInfo')), 1)]), _createElementVNode("tr", _hoisted_109, [_createElementVNode("td", null, _toDisplayString(_ctx.$t('storeLocation.supplier')) + "：" + _toDisplayString(controlScreenStoreLocationData.currentStoreLocation.installationVendorName), 1), _createElementVNode("td", null, _toDisplayString(_ctx.$t('storeLocation.contentManagement')) + "：" + _toDisplayString(controlScreenStoreLocationData.currentStoreLocation.contentManager), 1)]), _createElementVNode("tr", _hoisted_110, [_createElementVNode("td", null, _toDisplayString(_ctx.$t('storeLocation.installationDate')) + "：" + _toDisplayString(controlScreenStoreLocationData.currentStoreLocation.installationDate), 1), _createElementVNode("td", null, _toDisplayString(_ctx.$t('storeLocation.programTask')) + "：" + _toDisplayString(controlScreenStoreLocationData.currentStoreLocation.playTaskName), 1)]), _createElementVNode("tr", _hoisted_111, [_createElementVNode("td", null, _toDisplayString(_ctx.$t('storeLocation.warrantyEndDate')) + "：" + _toDisplayString(controlScreenStoreLocationData.currentStoreLocation.warrantyExpiryDate), 1), _createElementVNode("td", null, _toDisplayString(_ctx.$t('storeLocation.publishDate')) + "：" + _toDisplayString(controlScreenStoreLocationData.currentStoreLocation.playBeginTime), 1)])])])])]), _createElementVNode("div", _hoisted_112, [_createElementVNode("div", _hoisted_113, [_createVNode(MapWithMarkers, {
              ref_key: "screenFloorMapRef",
              ref: screenFloorMapRef,
              imageSrc: controlScreenStoreLocationData.currentFloor ? controlScreenStoreLocationData.currentFloor.storeFloorMap : '',
              selectId: screenSelectId.value,
              initialPoints: initialScreenPoints.value,
              onPointSelected: handleScreenFloorPointSelected
            }, null, 8, ["imageSrc", "selectId", "initialPoints"]), !controlScreenStoreLocationData.currentFloor || !controlScreenStoreLocationData.currentFloor.storeFloorMap ? (_openBlock(), _createElementBlock("div", _hoisted_114, _toDisplayString(_ctx.$t("storeLocation.noFloorPlan")), 1)) : _createCommentVNode("", true), _createVNode(_component_el_upload, {
              class: "logo-upload-box",
              ref_key: "uploadFloorMap",
              ref: uploadFloorMap,
              accept: "image/png, image/jpeg, image/gif, image/jpg",
              "show-file-list": false,
              action: uploadScreenFloorMapData.signatureData.host,
              "before-upload": file => {
                return handleScreenFloorMapBeforeUpload(file);
              },
              "on-success": handleScreenFloorMapBeforeOnSuccess,
              data: uploadScreenFloorMapData.data,
              "on-exceed": handleScreenFloorMapBeforeExceed,
              "file-list": uploadScreenFloorMapData.fileList
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_115, [_createVNode(_component_svg_icon, {
                iconName: "upload",
                iconColor: '#ffffff',
                iconSize: "16px"
              })])]),
              _: 1
            }, 8, ["action", "before-upload", "data", "file-list"]), controlScreenStoreLocationData.currentFloor && controlScreenStoreLocationData.currentFloor.storeFloorMap ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              style: {
                "width": "24px",
                "height": "24px",
                "border-radius": "50%",
                "bottom": "60px",
                "right": "30px",
                "position": "absolute",
                "display": "flex",
                "align-items": "center",
                "justify-content": "center"
              },
              class: _normalizeClass({
                edit_enable: locationPointHaveEdit() === true,
                edit_disable: locationPointHaveEdit() === false
              }),
              onClick: onScreenFloorMapOpen
            }, [_createVNode(_component_svg_icon, {
              iconName: "activityEdit",
              iconColor: '#ffffff',
              iconSize: "16px"
            })], 2)) : _createCommentVNode("", true), controlScreenStoreLocationData.currentFloor && controlScreenStoreLocationData.currentFloor.storeFloorMap ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              style: {
                "width": "24px",
                "height": "24px",
                "background-color": "#fa00a5",
                "border-radius": "50%",
                "bottom": "30px",
                "right": "30px",
                "position": "absolute",
                "display": "flex",
                "align-items": "center",
                "justify-content": "center",
                "cursor": "pointer"
              },
              onClick: onScreenFloorMapRemove
            }, [_createVNode(_component_svg_icon, {
              iconName: "tk_sub",
              iconColor: '#ffffff',
              iconSize: "16px"
            })])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_116, [_createElementVNode("div", _hoisted_117, [_createElementVNode("div", _hoisted_118, [_createVNode(_component_a_space, null, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(screenStoreLocationData.screenStoreLocationData.storeFloors, (location, index) => {
                return _openBlock(), _createElementBlock("div", {
                  class: _normalizeClass([{
                    active: controlScreenStoreLocationData.tab.tabIndex[0] === index
                  }, "filter-button"]),
                  key: index,
                  onClick: $event => changeStoreFoor(location.locationName, index, 0)
                }, _toDisplayString(location.locationName), 11, _hoisted_119);
              }), 128))]),
              _: 1
            })]), _createVNode(_component_a_divider, {
              style: {
                "margin": "10px 0px",
                "border-block-start": "1px solid #d7d4d4"
              }
            }), _createElementVNode("div", _hoisted_120, [_createVNode(_component_a_space, {
              style: {
                "display": "flex",
                "flex-wrap": "wrap"
              }
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(screenStoreLocationData.screenStoreLocationData.storeFloors[controlScreenStoreLocationData.tab.tabIndex[0]].locations, (location, index) => {
                return _openBlock(), _createElementBlock("div", {
                  class: _normalizeClass([{
                    active: controlScreenStoreLocationData.tab.tabIndex[1] === index
                  }, "filter-button"]),
                  key: index,
                  onClick: $event => changeStoreLocation(location, index, 1)
                }, [_createElementVNode("div", _hoisted_122, [_createElementVNode("div", _hoisted_123, _toDisplayString(location.locationName), 1)])], 10, _hoisted_121);
              }), 128))]),
              _: 1
            })]), _createVNode(_component_a_divider, {
              style: {
                "margin": "10px 0px",
                "border-block-start": "1px solid #d7d4d4"
              }
            }), _createElementVNode("div", _hoisted_124, [_createVNode(_component_a_space, {
              style: {
                "display": "flex",
                "flex-wrap": "wrap"
              }
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(screenStoreLocationData.screenStoreLocationData.storeFloors[controlScreenStoreLocationData.tab.tabIndex[0]].locations[controlScreenStoreLocationData.tab.tabIndex[1]].locations, (location, index) => {
                return _openBlock(), _createElementBlock("div", {
                  class: _normalizeClass([{
                    active: controlScreenStoreLocationData.tab.tabIndex[2] === index
                  }, "filter-button"]),
                  key: index,
                  onClick: $event => changeStoreLocation(location, index, 2)
                }, [_createElementVNode("div", _hoisted_126, [_createElementVNode("div", _hoisted_127, _toDisplayString(location.locationName), 1)])], 10, _hoisted_125);
              }), 128))]),
              _: 1
            })]), _createVNode(_component_a_divider, {
              style: {
                "margin": "10px 0px",
                "border-block-start": "1px solid #d7d4d4"
              }
            }), _createElementVNode("div", _hoisted_128, [_createVNode(_component_a_space, {
              style: {
                "display": "flex",
                "flex-wrap": "wrap"
              }
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(screenStoreLocationData.screenStoreLocationData.storeFloors[controlScreenStoreLocationData.tab.tabIndex[0]].locations[controlScreenStoreLocationData.tab.tabIndex[1]].locations[controlScreenStoreLocationData.tab.tabIndex[2]].locations, (location, index) => {
                return _openBlock(), _createElementBlock("div", {
                  class: _normalizeClass([{
                    active: controlScreenStoreLocationData.tab.tabIndex[3] === index
                  }, "filter-button"]),
                  key: index,
                  onClick: $event => changeStoreLocation(location, index, 3)
                }, [_createElementVNode("div", _hoisted_130, [_createElementVNode("div", _hoisted_131, _toDisplayString(location.locationName), 1)])], 10, _hoisted_129);
              }), 128))]),
              _: 1
            })]), _createVNode(_component_a_divider, {
              style: {
                "margin": "10px 0px",
                "border-block-start": "1px solid #d7d4d4"
              }
            }), _createElementVNode("div", _hoisted_132, [_createVNode(_component_a_space, {
              style: {
                "display": "flex",
                "flex-wrap": "wrap"
              }
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(screenStoreLocationData.screenStoreLocationData.storeFloors[controlScreenStoreLocationData.tab.tabIndex[0]].locations[controlScreenStoreLocationData.tab.tabIndex[1]].locations[controlScreenStoreLocationData.tab.tabIndex[2]].locations[controlScreenStoreLocationData.tab.tabIndex[3]].locations, (location, index) => {
                return _openBlock(), _createElementBlock("div", {
                  class: _normalizeClass([{
                    active: controlScreenStoreLocationData.tab.tabIndex[4] === index
                  }, "filter-button"]),
                  key: index,
                  onClick: $event => changeStoreLocation(location, index, 4)
                }, [_createElementVNode("div", _hoisted_134, [_createElementVNode("div", _hoisted_135, _toDisplayString(location.storeLocationName), 1), locationScreenHaveAdd(location) === true ? (_openBlock(), _createBlock(_component_svg_icon, {
                  key: 0,
                  style: {
                    "background-color": "rgb(0, 165, 250)",
                    "border-radius": "50%",
                    "margin-left": "3px"
                  },
                  iconName: "add",
                  iconColor: '#ffffff',
                  iconSize: "16px",
                  onClick: $event => onAddScreenPoint($event, location)
                }, null, 8, ["onClick"])) : _createCommentVNode("", true)])], 10, _hoisted_133);
              }), 128))]),
              _: 1
            })])])])])])], 512), [[_vShow, segmentedValue2.value === 'view']]), _withDirectives(_createElementVNode("div", _hoisted_136, [_createElementVNode("div", _hoisted_137, [_createElementVNode("div", _hoisted_138, _toDisplayString(_ctx.$t("storeLocation.floor")), 1), _createElementVNode("div", _hoisted_139, _toDisplayString(_ctx.$t("storeLocation.point")), 1), _createElementVNode("div", _hoisted_140, _toDisplayString(_ctx.$t("storeLocation.screenInfo")), 1), _createElementVNode("div", _hoisted_141, _toDisplayString(_ctx.$t("storeLocation.installationInfo")), 1), _createElementVNode("div", _hoisted_142, _toDisplayString(_ctx.$t("storeLocation.playInfo")), 1), _createElementVNode("div", _hoisted_143, _toDisplayString(_ctx.$t("storeLocation.video")), 1)]), _createElementVNode("div", _hoisted_144, [_createElementVNode("div", _hoisted_145, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(screenStoreLocationData.listData, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index,
                style: _normalizeStyle([{
                  "display": "flex",
                  "height": "170px",
                  "align-items": "center",
                  "flex-shrink": "0"
                }, {
                  backgroundColor: index % 2 === 0 ? '#ffffff' : '#f9f9f9'
                }])
              }, [_createElementVNode("div", _hoisted_146, _toDisplayString(item.storeFloor), 1), _createElementVNode("div", _hoisted_147, _toDisplayString(item.storeLocationName), 1), _createElementVNode("div", _hoisted_148, [_createElementVNode("table", _hoisted_149, [_createElementVNode("tbody", null, [_createElementVNode("tr", _hoisted_150, [_createElementVNode("td", null, [_createTextVNode(_toDisplayString(_ctx.$t('storeLocation.status')) + "： ", 1), item.deviceOnlineStatus == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_151, _toDisplayString(_ctx.$t('storeLocation.online')), 1)) : item.deviceOnlineStatus == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_152, _toDisplayString(_ctx.$t('storeLocation.offline')), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_153, _toDisplayString(_ctx.$t('storeLocation.disconnected')), 1))]), _createElementVNode("td", null, _toDisplayString(_ctx.$t('storeLocation.actualWidth')) + "：" + _toDisplayString(item.actualWidthMm) + "mm ", 1)]), _createElementVNode("tr", _hoisted_154, [_createElementVNode("td", null, _toDisplayString(_ctx.$t('storeLocation.screenType')) + "：" + _toDisplayString(item.screenDeviceCategoryName), 1), _createElementVNode("td", null, _toDisplayString(_ctx.$t('storeLocation.actualHeight')) + "：" + _toDisplayString(item.actualHeightMm) + "mm ", 1)]), _createElementVNode("tr", _hoisted_155, [_createElementVNode("td", null, _toDisplayString(_ctx.$t('storeLocation.pixelPitch')) + "：" + _toDisplayString(item.screenDeviceCategoryName == 'LCD' ? item.lcdInch : item.dotPitch), 1), _createElementVNode("td", null, _toDisplayString(_ctx.$t('storeLocation.resolution')) + "X：" + _toDisplayString(item.resolutionWidth), 1)]), _createElementVNode("tr", _hoisted_156, [_createElementVNode("td", null, _toDisplayString(_ctx.$t('storeLocation.aspectRatio')) + "：" + _toDisplayString(item.aspectRatio), 1), _createElementVNode("td", null, _toDisplayString(_ctx.$t('storeLocation.resolution')) + "Y：" + _toDisplayString(item.resolutionHeight), 1)])])])]), _createElementVNode("div", _hoisted_157, [_createElementVNode("table", _hoisted_158, [_createElementVNode("tbody", null, [_createElementVNode("tr", _hoisted_159, [_createElementVNode("td", null, _toDisplayString(_ctx.$t('storeLocation.installationDate')) + "：" + _toDisplayString(item.installationDate), 1)]), _createElementVNode("tr", _hoisted_160, [_createElementVNode("td", null, _toDisplayString(_ctx.$t('storeLocation.supplier')) + "：" + _toDisplayString(item.installationVendorName), 1)]), _createElementVNode("tr", _hoisted_161, [_createElementVNode("td", null, _toDisplayString(_ctx.$t('storeLocation.warrantyEndDate')) + "：" + _toDisplayString(item.warrantyExpiryDate), 1)])])])]), _createElementVNode("div", _hoisted_162, [_createElementVNode("table", _hoisted_163, [_createElementVNode("tbody", null, [_createElementVNode("tr", _hoisted_164, [_createElementVNode("td", null, _toDisplayString(_ctx.$t('storeLocation.programTask')) + "：" + _toDisplayString(item.playTaskName), 1)]), _createElementVNode("tr", _hoisted_165, [_createElementVNode("td", null, _toDisplayString(_ctx.$t('storeLocation.publishDate')) + "：" + _toDisplayString(item.playBeginTime), 1)]), _createElementVNode("tr", _hoisted_166, [_createElementVNode("td", null, _toDisplayString(_ctx.$t('storeLocation.contentManagement')) + "：" + _toDisplayString(item.contentManager), 1)])])])]), _createElementVNode("div", _hoisted_167, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.videos, (x, index) => {
                return _openBlock(), _createElementBlock("div", {
                  key: index,
                  style: {
                    "margin-right": "20px"
                  }
                }, [_createElementVNode("video", {
                  style: {
                    "width": "120px",
                    "height": "120px",
                    "cursor": "pointer",
                    "border": "1px solid #dedede"
                  },
                  disablePictureInPicture: "",
                  src: x.uploadedName,
                  onClick: $event => preViewVideo(x.uploadedName)
                }, null, 8, _hoisted_168)]);
              }), 128))])], 4);
            }), 128))])])], 512), [[_vShow, segmentedValue2.value === 'list']])])]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["activeKey"])]),
        _: 1
      })])])]), _createVNode(_component_a_modal, {
        open: screenFloorMapOpen.value,
        "onUpdate:open": _cache[9] || (_cache[9] = $event => screenFloorMapOpen.value = $event),
        closable: false,
        width: "764px",
        zIndex: 1001,
        centered: true,
        maskClosable: false
      }, {
        title: _withCtx(() => [_createElementVNode("div", _hoisted_169, [_createElementVNode("div", _hoisted_170, _toDisplayString(controlScreenStoreLocationData.locationLabel) + " " + _toDisplayString(_ctx.$t("storeLocation.firstFloorWomenArea")), 1), _hoisted_171, _createVNode(_component_a_button, {
          onClick: clearScreenPoint,
          style: {
            "border-radius": "4px",
            "height": "25px",
            "padding": "0px 15px",
            "margin-left": "10px"
          },
          class: "sts-button danger"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("storeLocation.clear")), 1)]),
          _: 1
        })])]),
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_173, [_createVNode(_component_a_space, null, {
          default: _withCtx(() => [_hoisted_174, _createVNode(_component_a_input, {
            value: dialogControlScreenData.x,
            "onUpdate:value": _cache[6] || (_cache[6] = $event => dialogControlScreenData.x = $event),
            style: {
              "width": "80px"
            }
          }, null, 8, ["value"]), _hoisted_175, _createVNode(_component_a_input, {
            value: dialogControlScreenData.y,
            "onUpdate:value": _cache[7] || (_cache[7] = $event => dialogControlScreenData.y = $event),
            style: {
              "width": "80px"
            }
          }, null, 8, ["value"])]),
          _: 1
        }), _hoisted_176, _createVNode(_component_a_button, {
          class: "sts-button default",
          key: "back",
          onClick: _cache[8] || (_cache[8] = $event => screenFloorMapOpen.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("storeLocation.cancel")), 1)]),
          _: 1
        }), _createVNode(_component_a_button, {
          class: "sts-button green",
          key: "submit",
          type: "primary",
          onClick: onSaveScreenPoint
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("storeLocation.save")), 1)]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_172, [screenFloorMapOpen.value ? (_openBlock(), _createBlock(MapWithMarkers, {
          key: 0,
          ref_key: "dialogScreenFloorMapRef",
          ref: dialogScreenFloorMapRef,
          imageSrc: controlScreenStoreLocationData.currentFloor.storeFloorMap,
          initialPoints: dialogControlScreenData.points,
          onPointSelected: handleDialogScreenFloorPointSelected,
          onPointChanged: handleDialogScreenFloorPointChanged
        }, null, 8, ["imageSrc", "initialPoints"])) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["open"]), _createVNode(_component_a_modal, {
        open: repairOpenVisible.value,
        "onUpdate:open": _cache[17] || (_cache[17] = $event => repairOpenVisible.value = $event),
        closable: false,
        zIndex: 1001,
        width: 700,
        centered: true
      }, {
        title: _withCtx(() => [_createElementVNode("div", _hoisted_177, [_createElementVNode("span", _hoisted_178, _toDisplayString(_ctx.$t("storeLocation.repairInfo")), 1), _createVNode(_component_a_divider, {
          style: {
            "margin": "10px 30px 10px 20px",
            "min-width": "0px"
          }
        })])]),
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_181, [_createVNode(_component_a_divider, {
          style: {
            "margin": "10px 30px 10px 0px",
            "min-width": "0px"
          }
        }), _createVNode(_component_a_button, {
          class: "sts-button default",
          key: "back",
          onClick: onRepairCancel
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("storeLocation.cancel")), 1)]),
          _: 1
        }), _createVNode(_component_a_button, {
          class: "sts-button green",
          key: "submit",
          type: "primary",
          onClick: onRepairSave
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("storeLocation.save")), 1)]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_179, [_createElementVNode("img", {
          style: {
            "width": "150px",
            "height": "150px"
          },
          src: wxCodeImage.value
        }, null, 8, _hoisted_180)]), _createVNode(_component_a_form, {
          model: repairEditFormData.value,
          ref_key: "repairEditForm",
          ref: repairEditForm,
          class: "sts-form",
          "label-col": {
            span: 8
          },
          "label-align": "left",
          autocomplete: "off"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_row, null, {
            default: _withCtx(() => [_createVNode(_component_a_col, null, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                label: _ctx.$t('storeLocation.repairStore'),
                name: "storeName",
                style: {
                  "width": "450px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_a_input, {
                  value: repairEditFormData.value.storeName,
                  "onUpdate:value": _cache[10] || (_cache[10] = $event => repairEditFormData.value.storeName = $event)
                }, null, 8, ["value"])]),
                _: 1
              }, 8, ["label"]), _createVNode(_component_a_form_item, {
                label: _ctx.$t('storeLocation.point'),
                name: "storeLocationId",
                style: {
                  "width": "450px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_a_tree_select, {
                  value: repairEditFormData.value.storeLocationId,
                  "onUpdate:value": _cache[11] || (_cache[11] = $event => repairEditFormData.value.storeLocationId = $event),
                  treeData: storeLocationData.treeOptionData,
                  treeDefaultExpandAll: true,
                  defaultExpandAll: "",
                  fieldNames: storeLocationTreeProps,
                  onChange: repairStoreLocationChange,
                  treeNodeLabelProp: 'fullPath',
                  style: {
                    "width": "300px"
                  }
                }, {
                  suffixIcon: _withCtx(() => [_createVNode(_unref(DownCircleOutlined), {
                    class: "ant-select-suffix"
                  })]),
                  _: 1
                }, 8, ["value", "treeData"])]),
                _: 1
              }, 8, ["label"]), _createVNode(_component_a_form_item, {
                label: _ctx.$t('storeLocation.customPoint'),
                name: "customStoreLocation",
                rules: customStoreLocationRules.value,
                style: {
                  "width": "450px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_a_input, {
                  disabled: repairEditFormData.value.storeLocationId != 0,
                  value: repairEditFormData.value.customStoreLocation,
                  "onUpdate:value": _cache[12] || (_cache[12] = $event => repairEditFormData.value.customStoreLocation = $event)
                }, null, 8, ["disabled", "value"])]),
                _: 1
              }, 8, ["label", "rules"]), _createVNode(_component_a_form_item, {
                label: _ctx.$t('storeLocation.repairPerson'),
                name: "reporterName",
                rules: [{
                  required: true,
                  message: _ctx.$t('storeLocation.repairPersonPlaceholder')
                }],
                style: {
                  "width": "450px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_a_input, {
                  value: repairEditFormData.value.reporterName,
                  "onUpdate:value": _cache[13] || (_cache[13] = $event => repairEditFormData.value.reporterName = $event)
                }, null, 8, ["value"])]),
                _: 1
              }, 8, ["label", "rules"]), _createVNode(_component_a_form_item, {
                label: _ctx.$t('storeLocation.contactMethod'),
                name: "reporterMobile",
                rules: [{
                  required: true,
                  message: _ctx.$t('storeLocation.contactMethodPlaceholder')
                }],
                style: {
                  "width": "450px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_a_input, {
                  value: repairEditFormData.value.reporterMobile,
                  "onUpdate:value": _cache[14] || (_cache[14] = $event => repairEditFormData.value.reporterMobile = $event)
                }, null, 8, ["value"])]),
                _: 1
              }, 8, ["label", "rules"]), _createVNode(_component_a_form_item, {
                label: _ctx.$t('storeLocation.emergencyCheck'),
                name: "repairUrgent",
                rules: [{
                  required: true,
                  message: _ctx.$t('storeLocation.emergencyCheckPlaceholder')
                }],
                style: {
                  "width": "450px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_a_select, {
                  "show-search": "",
                  dropdownMatchSelectWidth: false,
                  options: [{
                    label: _ctx.$t('storeLocation.yes'),
                    value: 1
                  }, {
                    label: _ctx.$t('storeLocation.no'),
                    value: 0
                  }],
                  style: {
                    "width": "110px"
                  },
                  popupClassName: "sts-select-dropdown",
                  value: repairEditFormData.value.repairUrgent,
                  "onUpdate:value": _cache[15] || (_cache[15] = $event => repairEditFormData.value.repairUrgent = $event)
                }, {
                  suffixIcon: _withCtx(() => [_createVNode(_unref(DownCircleOutlined), {
                    class: "ant-select-suffix"
                  })]),
                  _: 1
                }, 8, ["options", "value"])]),
                _: 1
              }, 8, ["label", "rules"]), _createVNode(_component_a_form_item, {
                label: _ctx.$t('storeLocation.description'),
                name: "reporterDescription",
                rules: [{
                  required: true,
                  message: _ctx.$t('storeLocation.descriptionPlaceholder')
                }],
                style: {
                  "width": "450px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_a_textarea, {
                  "auto-size": {
                    minRows: 2
                  },
                  value: repairEditFormData.value.reporterDescription,
                  "onUpdate:value": _cache[16] || (_cache[16] = $event => repairEditFormData.value.reporterDescription = $event)
                }, null, 8, ["value"])]),
                _: 1
              }, 8, ["label", "rules"]), _createVNode(_component_a_form_item, {
                label: _ctx.$t('storeLocation.faultPhoto'),
                style: {
                  "width": "450px"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_upload, {
                  class: "repair_upload",
                  "file-list": uploadTableData.fileList,
                  "list-type": "picture-card",
                  "on-preview": handlePictureCardPreview,
                  "on-remove": handleRemove,
                  limit: 3,
                  ref_key: "uploadTable",
                  ref: uploadTable,
                  action: uploadTableData.signatureData.host,
                  "before-upload": handleStoreBeforeUpload,
                  "on-exceed": handleExceed,
                  "before-remove": _ctx.handleBeforeRemove,
                  "on-success": handleStoreOnSuccess,
                  data: uploadTableData.data,
                  accept: "image/*"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [_createVNode(_unref(Plus))]),
                    _: 1
                  })]),
                  _: 1
                }, 8, ["file-list", "action", "before-remove", "data"])]),
                _: 1
              }, 8, ["label"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["open"]), _createVNode(_component_el_dialog, {
        modelValue: QRcodeVisible.value,
        "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => QRcodeVisible.value = $event),
        width: "30%",
        "align-center": "",
        modal: false,
        "append-to-body": "",
        style: {
          "min-width": "300px",
          "max-width": "300px",
          "min-height": "300px"
        },
        "show-close": false
      }, {
        header: _withCtx(() => [_hoisted_186, _createElementVNode("div", _hoisted_187, [_createVNode(_component_svg_icon, {
          iconName: "copy",
          iconSize: "20px",
          onClick: _cache[18] || (_cache[18] = $event => copyQrcode())
        })])]),
        default: _withCtx(() => [_createElementVNode("div", {
          style: {
            "display": "flex",
            "flex-direction": "column",
            "align-items": "center"
          },
          id: "QRcodeBox",
          ref_key: "QRcodeBox",
          ref: QRcodeBox
        }, [_createElementVNode("div", _hoisted_182, _toDisplayString(_ctx.$t("storeLocation.scanRepair")), 1), _createElementVNode("div", _hoisted_183, [_createElementVNode("img", {
          style: {
            "width": "150px",
            "height": "150px"
          },
          src: wxCodeImage.value
        }, null, 8, _hoisted_184)]), _hoisted_185], 512)]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_a_modal, {
        open: floorMapOpen.value,
        "onUpdate:open": _cache[23] || (_cache[23] = $event => floorMapOpen.value = $event),
        closable: false,
        width: "764px",
        zIndex: 1001,
        centered: true,
        maskClosable: false
      }, {
        title: _withCtx(() => [_createElementVNode("div", _hoisted_188, [_createElementVNode("div", _hoisted_189, _toDisplayString(controlData.locationLabel) + " " + _toDisplayString(_ctx.$t("storeLocation.firstFloorWomenArea")), 1), _hoisted_190, _createVNode(_component_a_button, {
          onClick: clearPoint,
          style: {
            "border-radius": "4px",
            "height": "25px",
            "padding": "0px 15px",
            "margin-left": "10px"
          },
          class: "sts-button danger"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("storeLocation.clear")), 1)]),
          _: 1
        })])]),
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_192, [_createVNode(_component_a_space, null, {
          default: _withCtx(() => [_hoisted_193, _createVNode(_component_a_input, {
            value: dialogControlData.x,
            "onUpdate:value": _cache[20] || (_cache[20] = $event => dialogControlData.x = $event),
            style: {
              "width": "80px"
            }
          }, null, 8, ["value"]), _hoisted_194, _createVNode(_component_a_input, {
            value: dialogControlData.y,
            "onUpdate:value": _cache[21] || (_cache[21] = $event => dialogControlData.y = $event),
            style: {
              "width": "80px"
            }
          }, null, 8, ["value"])]),
          _: 1
        }), _hoisted_195, _createVNode(_component_a_button, {
          class: "sts-button default",
          key: "back",
          onClick: _cache[22] || (_cache[22] = $event => floorMapOpen.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("storeLocation.cancel")), 1)]),
          _: 1
        }), _createVNode(_component_a_button, {
          class: "sts-button green",
          key: "submit",
          type: "primary",
          onClick: onSavePoint
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("storeLocation.save")), 1)]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_191, [floorMapOpen.value ? (_openBlock(), _createBlock(MapWithMarkers, {
          key: 0,
          ref_key: "dialogFloorMapRef",
          ref: dialogFloorMapRef,
          imageSrc: controlData.currentFloor.storeFloorMap,
          initialPoints: dialogControlData.points,
          onPointSelected: handleDialogFloorPointSelected,
          onPointChanged: handleDialogFloorPointChanged
        }, null, 8, ["imageSrc", "initialPoints"])) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["open"]), _createVNode(_component_a_modal, {
        open: videoOpen.value,
        "onUpdate:open": _cache[24] || (_cache[24] = $event => videoOpen.value = $event),
        title: "视频预览",
        width: "700px",
        footer: null
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_196, [_createElementVNode("video", {
          autoplay: "",
          loop: "",
          src: videoUrl.value,
          style: {
            "width": "480px",
            "height": "480px"
          },
          controls: ""
        }, null, 8, _hoisted_197)])]),
        _: 1
      }, 8, ["open"])], 64);
    };
  }
};